var pa = Object.defineProperty;
var wa = (e, t, n) => t in e ? pa(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var xt = (e, t, n) => (wa(e, typeof t != "symbol" ? t + "" : t, n), n);
import * as xa from "react";
import { useState as me, useCallback as ee, useMemo as be, useEffect as ae, useContext as ba, useDebugValue as Ma, createElement as yn, Component as Ta, useRef as fr, Fragment as Ca } from "react";
import { jsx as h, jsxs as X, Fragment as Gt } from "react/jsx-runtime";
import { createPortal as Sa } from "react-dom";
const Zt = xa.createContext(null);
process.env.NODE_ENV !== "production" && (Zt.displayName = "TimelineThemeContext");
const Da = ({
  theme: e,
  children: t
}) => /* @__PURE__ */ h(Zt.Provider, {
  value: e,
  children: t
});
function dr(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Jt(e) {
  let t = e, n = e;
  e.length === 1 && (t = (i, u) => e(i) - u, n = ka(e));
  function r(i, u, c, s) {
    for (c == null && (c = 0), s == null && (s = i.length); c < s; ) {
      const l = c + s >>> 1;
      n(i[l], u) < 0 ? c = l + 1 : s = l;
    }
    return c;
  }
  function a(i, u, c, s) {
    for (c == null && (c = 0), s == null && (s = i.length); c < s; ) {
      const l = c + s >>> 1;
      n(i[l], u) > 0 ? s = l : c = l + 1;
    }
    return c;
  }
  function o(i, u, c, s) {
    c == null && (c = 0), s == null && (s = i.length);
    const l = r(i, u, c, s - 1);
    return l > c && t(i[l - 1], u) > -t(i[l], u) ? l - 1 : l;
  }
  return { left: r, center: o, right: a };
}
function ka(e) {
  return (t, n) => dr(e(t), n);
}
function Oa(e) {
  return e === null ? NaN : +e;
}
const Ea = Jt(dr), Ua = Ea.right;
Jt(Oa).center;
const Na = Ua;
function Ya(e, t) {
  let n, r;
  if (t === void 0)
    for (const a of e)
      a != null && (n === void 0 ? a >= a && (n = r = a) : (n > a && (n = a), r < a && (r = a)));
  else {
    let a = -1;
    for (let o of e)
      (o = t(o, ++a, e)) != null && (n === void 0 ? o >= o && (n = r = o) : (n > o && (n = o), r < o && (r = o)));
  }
  return [n, r];
}
class Fa extends Map {
  constructor(t, n = Pa) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null)
      for (const [r, a] of t)
        this.set(r, a);
  }
  get(t) {
    return super.get(pn(this, t));
  }
  has(t) {
    return super.has(pn(this, t));
  }
  set(t, n) {
    return super.set(Wa(this, t), n);
  }
  delete(t) {
    return super.delete(_a(this, t));
  }
}
function pn({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function Wa({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function _a({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(n), e.delete(r)), n;
}
function Pa(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function Ha(e) {
  return e;
}
function $a(e, ...t) {
  return Aa(e, Array.from, Ha, t);
}
function Aa(e, t, n, r) {
  return function a(o, i) {
    if (i >= r.length)
      return n(o);
    const u = new Fa(), c = r[i++];
    let s = -1;
    for (const l of o) {
      const f = c(l, ++s, o), d = u.get(f);
      d ? d.push(l) : u.set(f, [l]);
    }
    for (const [l, f] of u)
      u.set(l, a(f, i));
    return t(u);
  }(e, 0);
}
var Ht = Math.sqrt(50), $t = Math.sqrt(10), At = Math.sqrt(2);
function Ia(e, t, n) {
  var r, a = -1, o, i, u;
  if (t = +t, e = +e, n = +n, e === t && n > 0)
    return [e];
  if ((r = t < e) && (o = e, e = t, t = o), (u = hr(e, t, n)) === 0 || !isFinite(u))
    return [];
  if (u > 0) {
    let c = Math.round(e / u), s = Math.round(t / u);
    for (c * u < e && ++c, s * u > t && --s, i = new Array(o = s - c + 1); ++a < o; )
      i[a] = (c + a) * u;
  } else {
    u = -u;
    let c = Math.round(e * u), s = Math.round(t * u);
    for (c / u < e && ++c, s / u > t && --s, i = new Array(o = s - c + 1); ++a < o; )
      i[a] = (c + a) / u;
  }
  return r && i.reverse(), i;
}
function hr(e, t, n) {
  var r = (t - e) / Math.max(0, n), a = Math.floor(Math.log(r) / Math.LN10), o = r / Math.pow(10, a);
  return a >= 0 ? (o >= Ht ? 10 : o >= $t ? 5 : o >= At ? 2 : 1) * Math.pow(10, a) : -Math.pow(10, -a) / (o >= Ht ? 10 : o >= $t ? 5 : o >= At ? 2 : 1);
}
function It(e, t, n) {
  var r = Math.abs(t - e) / Math.max(0, n), a = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), o = r / a;
  return o >= Ht ? a *= 10 : o >= $t ? a *= 5 : o >= At && (a *= 2), t < e ? -a : a;
}
function La(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n < r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let a of e)
      (a = t(a, ++r, e)) != null && (n < a || n === void 0 && a >= a) && (n = a);
  }
  return n;
}
function Ra(e, t) {
  let n;
  if (t === void 0)
    for (const r of e)
      r != null && (n > r || n === void 0 && r >= r) && (n = r);
  else {
    let r = -1;
    for (let a of e)
      (a = t(a, ++r, e)) != null && (n > a || n === void 0 && a >= a) && (n = a);
  }
  return n;
}
function qa(e, t, n) {
  e = +e, t = +t, n = (a = arguments.length) < 2 ? (t = e, e = 0, 1) : a < 3 ? 1 : +n;
  for (var r = -1, a = Math.max(0, Math.ceil((t - e) / n)) | 0, o = new Array(a); ++r < a; )
    o[r] = e + r * n;
  return o;
}
function re(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function R(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function it(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? it = function(n) {
    return typeof n;
  } : it = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, it(e);
}
function j(e) {
  R(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || it(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
function za(e, t) {
  R(2, arguments);
  var n = j(e), r = re(t);
  return isNaN(r) ? new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Xa(e, t) {
  R(2, arguments);
  var n = j(e), r = re(t);
  if (isNaN(r))
    return new Date(NaN);
  if (!r)
    return n;
  var a = n.getDate(), o = new Date(n.getTime());
  o.setMonth(n.getMonth() + r + 1, 0);
  var i = o.getDate();
  return a >= i ? o : (n.setFullYear(o.getFullYear(), o.getMonth(), a), n);
}
function ja(e, t) {
  R(2, arguments);
  var n = j(e).getTime(), r = re(t);
  return new Date(n + r);
}
var Va = {};
function Pe() {
  return Va;
}
function Ba(e, t) {
  var n, r, a, o, i, u, c, s;
  R(1, arguments);
  var l = Pe(), f = re((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : l.weekStartsOn) !== null && r !== void 0 ? r : (c = l.locale) === null || c === void 0 || (s = c.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = j(e), g = d.getDay(), v = (g < f ? 7 : 0) + g - f;
  return d.setDate(d.getDate() - v), d.setHours(0, 0, 0, 0), d;
}
function Qa(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function wn(e, t) {
  R(2, arguments);
  var n = re(t), r = n * 7;
  return za(e, r);
}
function ut(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ut = function(n) {
    return typeof n;
  } : ut = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ut(e);
}
function Ga(e) {
  return R(1, arguments), e instanceof Date || ut(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Za(e) {
  if (R(1, arguments), !Ga(e) && typeof e != "number")
    return !1;
  var t = j(e);
  return !isNaN(Number(t));
}
function Ja(e) {
  R(1, arguments);
  var t = j(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Ka(e, t) {
  var n, r, a, o, i, u, c, s;
  R(1, arguments);
  var l = Pe(), f = re((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : l.weekStartsOn) !== null && r !== void 0 ? r : (c = l.locale) === null || c === void 0 || (s = c.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = j(e), g = d.getDay(), v = (g < f ? -7 : 0) + 6 - (g - f);
  return d.setDate(d.getDate() + v), d.setHours(23, 59, 59, 999), d;
}
function eo(e, t) {
  R(2, arguments);
  var n = re(t);
  return ja(e, -n);
}
var to = 864e5;
function no(e) {
  R(1, arguments);
  var t = j(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), a = n - r;
  return Math.floor(a / to) + 1;
}
function st(e) {
  R(1, arguments);
  var t = 1, n = j(e), r = n.getUTCDay(), a = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function mr(e) {
  R(1, arguments);
  var t = j(e), n = t.getUTCFullYear(), r = new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = st(r), o = new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = st(o);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function ro(e) {
  R(1, arguments);
  var t = mr(e), n = new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = st(n);
  return r;
}
var ao = 6048e5;
function oo(e) {
  R(1, arguments);
  var t = j(e), n = st(t).getTime() - ro(t).getTime();
  return Math.round(n / ao) + 1;
}
function ct(e, t) {
  var n, r, a, o, i, u, c, s;
  R(1, arguments);
  var l = Pe(), f = re((n = (r = (a = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && a !== void 0 ? a : l.weekStartsOn) !== null && r !== void 0 ? r : (c = l.locale) === null || c === void 0 || (s = c.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var d = j(e), g = d.getUTCDay(), v = (g < f ? 7 : 0) + g - f;
  return d.setUTCDate(d.getUTCDate() - v), d.setUTCHours(0, 0, 0, 0), d;
}
function gr(e, t) {
  var n, r, a, o, i, u, c, s;
  R(1, arguments);
  var l = j(e), f = l.getUTCFullYear(), d = Pe(), g = re((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = d.locale) === null || c === void 0 || (s = c.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = new Date(0);
  v.setUTCFullYear(f + 1, 0, g), v.setUTCHours(0, 0, 0, 0);
  var T = ct(v, t), y = new Date(0);
  y.setUTCFullYear(f, 0, g), y.setUTCHours(0, 0, 0, 0);
  var b = ct(y, t);
  return l.getTime() >= T.getTime() ? f + 1 : l.getTime() >= b.getTime() ? f : f - 1;
}
function io(e, t) {
  var n, r, a, o, i, u, c, s;
  R(1, arguments);
  var l = Pe(), f = re((n = (r = (a = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (i = t.locale) === null || i === void 0 || (u = i.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : l.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = l.locale) === null || c === void 0 || (s = c.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), d = gr(e, t), g = new Date(0);
  g.setUTCFullYear(d, 0, f), g.setUTCHours(0, 0, 0, 0);
  var v = ct(g, t);
  return v;
}
var uo = 6048e5;
function so(e, t) {
  R(1, arguments);
  var n = j(e), r = ct(n, t).getTime() - io(n, t).getTime();
  return Math.round(r / uo) + 1;
}
function _(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var co = {
  y: function(t, n) {
    var r = t.getUTCFullYear(), a = r > 0 ? r : 1 - r;
    return _(n === "yy" ? a % 100 : a, n.length);
  },
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : _(r + 1, 2);
  },
  d: function(t, n) {
    return _(t.getUTCDate(), n.length);
  },
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  h: function(t, n) {
    return _(t.getUTCHours() % 12 || 12, n.length);
  },
  H: function(t, n) {
    return _(t.getUTCHours(), n.length);
  },
  m: function(t, n) {
    return _(t.getUTCMinutes(), n.length);
  },
  s: function(t, n) {
    return _(t.getUTCSeconds(), n.length);
  },
  S: function(t, n) {
    var r = n.length, a = t.getUTCMilliseconds(), o = Math.floor(a * Math.pow(10, r - 3));
    return _(o, n.length);
  }
};
const he = co;
var Oe = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, lo = {
  G: function(t, n, r) {
    var a = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(a, {
          width: "wide"
        });
    }
  },
  y: function(t, n, r) {
    if (n === "yo") {
      var a = t.getUTCFullYear(), o = a > 0 ? a : 1 - a;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return he.y(t, n);
  },
  Y: function(t, n, r, a) {
    var o = gr(t, a), i = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var u = i % 100;
      return _(u, 2);
    }
    return n === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : _(i, n.length);
  },
  R: function(t, n) {
    var r = mr(t);
    return _(r, n.length);
  },
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return _(r, n.length);
  },
  Q: function(t, n, r) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return _(a, 2);
      case "Qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(t, n, r) {
    var a = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return _(a, 2);
      case "qo":
        return r.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(t, n, r) {
    var a = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return he.M(t, n);
      case "Mo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function(t, n, r) {
    var a = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return _(a + 1, 2);
      case "Lo":
        return r.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function(t, n, r, a) {
    var o = so(t, a);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : _(o, n.length);
  },
  I: function(t, n, r) {
    var a = oo(t);
    return n === "Io" ? r.ordinalNumber(a, {
      unit: "week"
    }) : _(a, n.length);
  },
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : he.d(t, n);
  },
  D: function(t, n, r) {
    var a = no(t);
    return n === "Do" ? r.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : _(a, n.length);
  },
  E: function(t, n, r) {
    var a = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(t, n, r, a) {
    var o = t.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(i);
      case "ee":
        return _(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(t, n, r, a) {
    var o = t.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(i);
      case "cc":
        return _(i, n.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(t, n, r) {
    var a = t.getUTCDay(), o = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return _(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(t, n, r) {
    var a = t.getUTCHours(), o = a / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(t, n, r) {
    var a = t.getUTCHours(), o;
    switch (a === 12 ? o = Oe.noon : a === 0 ? o = Oe.midnight : o = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(t, n, r) {
    var a = t.getUTCHours(), o;
    switch (a >= 17 ? o = Oe.evening : a >= 12 ? o = Oe.afternoon : a >= 4 ? o = Oe.morning : o = Oe.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(t, n, r) {
    if (n === "ho") {
      var a = t.getUTCHours() % 12;
      return a === 0 && (a = 12), r.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return he.h(t, n);
  },
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : he.H(t, n);
  },
  K: function(t, n, r) {
    var a = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : _(a, n.length);
  },
  k: function(t, n, r) {
    var a = t.getUTCHours();
    return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
      unit: "hour"
    }) : _(a, n.length);
  },
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : he.m(t, n);
  },
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : he.s(t, n);
  },
  S: function(t, n) {
    return he.S(t, n);
  },
  X: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (n) {
      case "X":
        return bn(i);
      case "XXXX":
      case "XX":
        return xe(i);
      case "XXXXX":
      case "XXX":
      default:
        return xe(i, ":");
    }
  },
  x: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return bn(i);
      case "xxxx":
      case "xx":
        return xe(i);
      case "xxxxx":
      case "xxx":
      default:
        return xe(i, ":");
    }
  },
  O: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + xn(i, ":");
      case "OOOO":
      default:
        return "GMT" + xe(i, ":");
    }
  },
  z: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + xn(i, ":");
      case "zzzz":
      default:
        return "GMT" + xe(i, ":");
    }
  },
  t: function(t, n, r, a) {
    var o = a._originalDate || t, i = Math.floor(o.getTime() / 1e3);
    return _(i, n.length);
  },
  T: function(t, n, r, a) {
    var o = a._originalDate || t, i = o.getTime();
    return _(i, n.length);
  }
};
function xn(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), a = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(a);
  var i = t || "";
  return n + String(a) + i + _(o, 2);
}
function bn(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + _(Math.abs(e) / 60, 2);
  }
  return xe(e, t);
}
function xe(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", a = Math.abs(e), o = _(Math.floor(a / 60), 2), i = _(a % 60, 2);
  return r + o + n + i;
}
const fo = lo;
var Mn = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, vr = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, ho = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], a = r[1], o = r[2];
  if (!o)
    return Mn(t, n);
  var i;
  switch (a) {
    case "P":
      i = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = n.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Mn(a, n)).replace("{{time}}", vr(o, n));
}, mo = {
  p: vr,
  P: ho
};
const go = mo;
var vo = ["D", "DD"], yo = ["YY", "YYYY"];
function po(e) {
  return vo.indexOf(e) !== -1;
}
function wo(e) {
  return yo.indexOf(e) !== -1;
}
function Tn(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var xo = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, bo = function(t, n, r) {
  var a, o = xo[t];
  return typeof o == "string" ? a = o : n === 1 ? a = o.one : a = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
};
const Mo = bo;
function bt(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var To = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Co = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, So = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Do = {
  date: bt({
    formats: To,
    defaultWidth: "full"
  }),
  time: bt({
    formats: Co,
    defaultWidth: "full"
  }),
  dateTime: bt({
    formats: So,
    defaultWidth: "full"
  })
};
const ko = Do;
var Oo = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Eo = function(t, n, r, a) {
  return Oo[t];
};
const Uo = Eo;
function Le(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", a;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : o;
      a = e.formattingValues[i] || e.formattingValues[o];
    } else {
      var u = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[c] || e.values[u];
    }
    var s = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[s];
  };
}
var No = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Yo = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Fo = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Wo = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, _o = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Po = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ho = function(t, n) {
  var r = Number(t), a = r % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, $o = {
  ordinalNumber: Ho,
  era: Le({
    values: No,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: Yo,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Le({
    values: Fo,
    defaultWidth: "wide"
  }),
  day: Le({
    values: Wo,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: _o,
    defaultWidth: "wide",
    formattingValues: Po,
    defaultFormattingWidth: "wide"
  })
};
const Ao = $o;
function Re(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(a);
    if (!o)
      return null;
    var i = o[0], u = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(u) ? Lo(u, function(f) {
      return f.test(i);
    }) : Io(u, function(f) {
      return f.test(i);
    }), s;
    s = e.valueCallback ? e.valueCallback(c) : c, s = n.valueCallback ? n.valueCallback(s) : s;
    var l = t.slice(i.length);
    return {
      value: s,
      rest: l
    };
  };
}
function Io(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function Lo(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Ro(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var a = r[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var i = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    var u = t.slice(a.length);
    return {
      value: i,
      rest: u
    };
  };
}
var qo = /^(\d+)(th|st|nd|rd)?/i, zo = /\d+/i, Xo = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, jo = {
  any: [/^b/i, /^(a|c)/i]
}, Vo = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Bo = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qo = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Go = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Zo = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Jo = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Ko = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ei = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, ti = {
  ordinalNumber: Ro({
    matchPattern: qo,
    parsePattern: zo,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Re({
    matchPatterns: Xo,
    defaultMatchWidth: "wide",
    parsePatterns: jo,
    defaultParseWidth: "any"
  }),
  quarter: Re({
    matchPatterns: Vo,
    defaultMatchWidth: "wide",
    parsePatterns: Bo,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Re({
    matchPatterns: Qo,
    defaultMatchWidth: "wide",
    parsePatterns: Go,
    defaultParseWidth: "any"
  }),
  day: Re({
    matchPatterns: Zo,
    defaultMatchWidth: "wide",
    parsePatterns: Jo,
    defaultParseWidth: "any"
  }),
  dayPeriod: Re({
    matchPatterns: Ko,
    defaultMatchWidth: "any",
    parsePatterns: ei,
    defaultParseWidth: "any"
  })
};
const ni = ti;
var ri = {
  code: "en-US",
  formatDistance: Mo,
  formatLong: ko,
  formatRelative: Uo,
  localize: Ao,
  match: ni,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const ai = ri;
var oi = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ii = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, ui = /^'([^]*?)'?$/, si = /''/g, ci = /[a-zA-Z]/;
function Cn(e, t, n) {
  var r, a, o, i, u, c, s, l, f, d, g, v, T, y, b, W, D, p;
  R(2, arguments);
  var N = String(t), w = Pe(), C = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : w.locale) !== null && r !== void 0 ? r : ai, H = re((o = (i = (u = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (s = n.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && u !== void 0 ? u : w.firstWeekContainsDate) !== null && i !== void 0 ? i : (f = w.locale) === null || f === void 0 || (d = f.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(H >= 1 && H <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var M = re((g = (v = (T = (y = n == null ? void 0 : n.weekStartsOn) !== null && y !== void 0 ? y : n == null || (b = n.locale) === null || b === void 0 || (W = b.options) === null || W === void 0 ? void 0 : W.weekStartsOn) !== null && T !== void 0 ? T : w.weekStartsOn) !== null && v !== void 0 ? v : (D = w.locale) === null || D === void 0 || (p = D.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!(M >= 0 && M <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!C.localize)
    throw new RangeError("locale must contain localize property");
  if (!C.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var E = j(e);
  if (!Za(E))
    throw new RangeError("Invalid time value");
  var S = Qa(E), Q = eo(E, S), P = {
    firstWeekContainsDate: H,
    weekStartsOn: M,
    locale: C,
    _originalDate: E
  }, L = N.match(ii).map(function(I) {
    var q = I[0];
    if (q === "p" || q === "P") {
      var z = go[q];
      return z(I, C.formatLong);
    }
    return I;
  }).join("").match(oi).map(function(I) {
    if (I === "''")
      return "'";
    var q = I[0];
    if (q === "'")
      return li(I);
    var z = fo[q];
    if (z)
      return !(n != null && n.useAdditionalWeekYearTokens) && wo(I) && Tn(I, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && po(I) && Tn(I, t, String(e)), z(Q, I, C.localize, P);
    if (q.match(ci))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + q + "`");
    return I;
  }).join("");
  return L;
}
function li(e) {
  var t = e.match(ui);
  return t ? t[1].replace(si, "'") : e;
}
function fi(e, t) {
  R(2, arguments);
  var n = j(e), r = j(t);
  return n.getTime() < r.getTime();
}
function di(e, t) {
  R(2, arguments);
  var n = j(e), r = j(t);
  return n.getTime() === r.getTime();
}
const Ue = () => {
}, yr = (e, t) => new Array(t - e).fill(void 0).map((n, r) => r + e), Sn = (e, t, n) => Math.min(Math.max(e, t), n), Kt = (e, t) => Math.abs(Math.max(e, t) - Math.min(e, t)), je = 1e3, He = 60 * je, hi = 5 * He, mi = 10 * He, gi = 15 * He, vi = 30 * He, Ke = 60 * He, yi = 3 * Ke, pi = 6 * Ke, wi = 12 * Ke, yt = 24 * Ke, pr = 7 * yt, wr = 30 * yt, Lt = 365 * yt;
var te = /* @__PURE__ */ ((e) => (e.MIN = "minimum", e.TEN_MS = "10 ms", e.HUNDRED_MS = "100 ms", e.FIVEHUNDRED_MS = "500 ms", e.ONE_SEC = "1 sec", e.FIVE_SECS = "5 secs", e.TEN_SECS = "10 secs", e.THIRTY_SECS = "30 secs", e.ONE_MIN = "1 min", e.FIVE_MINS = "5 mins", e.TEN_MINS = "10 mins", e.FIFTEEN_MINS = "15 mins", e.THIRTY_MINS = "30 mins", e.ONE_HOUR = "1 hour", e.THREE_HOURS = "3 hours", e.SIX_HOURS = "6 hours", e.TWELVE_HOURS = "12 hours", e.ONE_DAY = "1 day", e.ONE_WEEK = "1 week", e.ONE_MONTH = "1 month", e.ONE_YEAR = "1 year", e.TEN_YEARS = "10 years", e.MAX = "maximum", e))(te || {});
const xi = [
  "10 years",
  "1 year",
  "1 month",
  "1 week",
  "1 day",
  "12 hours",
  "6 hours",
  "3 hours",
  "1 hour",
  "30 mins",
  "15 mins",
  "10 mins",
  "5 mins",
  "1 min"
], le = (e) => {
  switch (e) {
    case "maximum":
      return Number.MAX_SAFE_INTEGER;
    case "10 years":
      return 10 * Lt;
    case "1 year":
      return Lt;
    case "1 month":
      return wr;
    case "1 week":
      return pr;
    case "1 day":
      return yt;
    case "12 hours":
      return wi;
    case "6 hours":
      return pi;
    case "3 hours":
      return yi;
    case "1 hour":
      return Ke;
    case "30 mins":
      return vi;
    case "15 mins":
      return gi;
    case "10 mins":
      return mi;
    case "5 mins":
      return hi;
    case "1 min":
      return He;
    case "30 secs":
      return 30 * je;
    case "10 secs":
      return 10 * je;
    case "5 secs":
      return 5 * je;
    case "1 sec":
      return je;
    case "500 ms":
      return 500;
    case "100 ms":
      return 100;
    case "10 ms":
      return 10;
    case "minimum":
      return 0;
    default:
      return 0;
  }
}, bi = (e, t) => {
  const n = Kt(e[1], e[0]);
  return n > le(t[0]) ? "maximum" : n <= le("minimum") ? "minimum" : [...t].reverse().find((r) => n <= le(r)) || "maximum";
}, Mi = (e, t) => {
  const n = Kt(e[1], e[0]) / 2;
  return t.find((r) => le(r) <= n) || "minimum";
}, Ti = (e, t) => {
  const n = Kt(e[1], e[0]) * 2;
  return [...t].reverse().find((r) => le(r) > n) || "maximum";
}, xr = (e, t, n, r) => [
  Math.max(e, n - r / 2),
  Math.min(t, n + r / 2)
];
function Dn(e) {
  switch (e) {
    case te.MAX:
      return "yyyy";
    case te.TEN_YEARS:
      return "yyyy-MM";
    case te.ONE_YEAR:
      return "yyyy-MM-ww";
    case te.ONE_MONTH:
      return "yyyy-MM-ww-dd";
    case te.ONE_WEEK:
      return "yyyy-MM-ww-dd-aaa";
    case te.ONE_DAY:
      return "yyyy-MM-ww-dd-HH";
    case te.MIN:
      return "T";
    default:
      return "T";
  }
}
const kn = "isPinnedOrSelected", Ci = (e, t, n, r, a, o, i) => {
  const [u, c] = me(!1), s = ee(
    (v) => {
      c(!0), o(v);
    },
    [c, o]
  ), l = ee(
    (v) => {
      c(!1), i(v);
    },
    [c, i]
  ), [f, d, g] = be(() => {
    const v = e.filter((y) => {
      const b = y.startTimeMillis >= t[0] && y.startTimeMillis <= t[1], W = y.endTimeMillis && y.endTimeMillis >= t[0] && y.endTimeMillis <= t[1], D = y.endTimeMillis && y.startTimeMillis < t[0] && y.endTimeMillis > t[1];
      return b || W || D;
    }), T = v.some((y) => y.isSelected) === !1;
    return !a || n === te.ONE_DAY ? [v, [], T] : $a(
      v,
      (y) => y.isPinned || y.isSelected ? kn : `${r ? `${y.laneId}-` : ""}${Cn(y.startTimeMillis, Dn(n))}${y.endTimeMillis ? `-${Cn(y.endTimeMillis, Dn(n))}` : ""}`
    ).reduce(
      (y, b) => b[0] === kn || b[1].length <= 1 ? [[...y[0], ...b[1]], [...y[1]], T] : [
        [...y[0]],
        [
          ...y[1],
          {
            timeMillis: b[1].reduce(
              (W, D) => {
                var p;
                return W + (D.startTimeMillis + ((p = D.endTimeMillis) != null ? p : D.startTimeMillis)) / 2;
              },
              0
            ) / b[1].length,
            laneId: b[1][0].laneId,
            size: b[1].length
          }
        ],
        T
      ],
      [[], [], T]
    );
  }, [e, t, n, r, a]);
  return {
    eventsInsideDomain: f,
    eventClustersInsideDomain: d,
    isNoEventSelected: g,
    isMouseOverEvent: u,
    onEventHoverDecorated: s,
    onEventUnhoverDecorated: l
  };
};
function br(e, t) {
  const n = [...t].sort((r, a) => le(a) - le(r));
  return {
    currentZoomScale: bi(e, n),
    nextSmallerZoomScale: Mi(e, n),
    nextBiggerZoomScale: Ti(e, n)
  };
}
function et(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
const On = Symbol("implicit");
function Mr() {
  var e = /* @__PURE__ */ new Map(), t = [], n = [], r = On;
  function a(o) {
    var i = o + "", u = e.get(i);
    if (!u) {
      if (r !== On)
        return r;
      e.set(i, u = t.push(o));
    }
    return n[(u - 1) % n.length];
  }
  return a.domain = function(o) {
    if (!arguments.length)
      return t.slice();
    t = [], e = /* @__PURE__ */ new Map();
    for (const i of o) {
      const u = i + "";
      e.has(u) || e.set(u, t.push(i));
    }
    return a;
  }, a.range = function(o) {
    return arguments.length ? (n = Array.from(o), a) : n.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (r = o, a) : r;
  }, a.copy = function() {
    return Mr(t, n).unknown(r);
  }, et.apply(a, arguments), a;
}
function Tr() {
  var e = Mr().unknown(void 0), t = e.domain, n = e.range, r = 0, a = 1, o, i, u = !1, c = 0, s = 0, l = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, g = a < r, v = g ? a : r, T = g ? r : a;
    o = (T - v) / Math.max(1, d - c + s * 2), u && (o = Math.floor(o)), v += (T - v - o * (d - c)) * l, i = o * (1 - c), u && (v = Math.round(v), i = Math.round(i));
    var y = qa(d).map(function(b) {
      return v + o * b;
    });
    return n(g ? y.reverse() : y);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([r, a] = d, r = +r, a = +a, f()) : [r, a];
  }, e.rangeRound = function(d) {
    return [r, a] = d, r = +r, a = +a, u = !0, f();
  }, e.bandwidth = function() {
    return i;
  }, e.step = function() {
    return o;
  }, e.round = function(d) {
    return arguments.length ? (u = !!d, f()) : u;
  }, e.padding = function(d) {
    return arguments.length ? (c = Math.min(1, s = +d), f()) : c;
  }, e.paddingInner = function(d) {
    return arguments.length ? (c = Math.min(1, d), f()) : c;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (s = +d, f()) : s;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), f()) : l;
  }, e.copy = function() {
    return Tr(t(), [r, a]).round(u).paddingInner(c).paddingOuter(s).align(l);
  }, et.apply(f(), arguments);
}
function en(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function Cr(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t)
    n[r] = t[r];
  return n;
}
function tt() {
}
var Be = 0.7, lt = 1 / Be, Ne = "\\s*([+-]?\\d+)\\s*", Qe = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", ue = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Si = /^#([0-9a-f]{3,8})$/, Di = new RegExp("^rgb\\(" + [Ne, Ne, Ne] + "\\)$"), ki = new RegExp("^rgb\\(" + [ue, ue, ue] + "\\)$"), Oi = new RegExp("^rgba\\(" + [Ne, Ne, Ne, Qe] + "\\)$"), Ei = new RegExp("^rgba\\(" + [ue, ue, ue, Qe] + "\\)$"), Ui = new RegExp("^hsl\\(" + [Qe, ue, ue] + "\\)$"), Ni = new RegExp("^hsla\\(" + [Qe, ue, ue, Qe] + "\\)$"), En = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
en(tt, Ge, {
  copy: function(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: Un,
  formatHex: Un,
  formatHsl: Yi,
  formatRgb: Nn,
  toString: Nn
});
function Un() {
  return this.rgb().formatHex();
}
function Yi() {
  return Sr(this).formatHsl();
}
function Nn() {
  return this.rgb().formatRgb();
}
function Ge(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = Si.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Yn(t) : n === 3 ? new K(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? nt(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? nt(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Di.exec(e)) ? new K(t[1], t[2], t[3], 1) : (t = ki.exec(e)) ? new K(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Oi.exec(e)) ? nt(t[1], t[2], t[3], t[4]) : (t = Ei.exec(e)) ? nt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Ui.exec(e)) ? _n(t[1], t[2] / 100, t[3] / 100, 1) : (t = Ni.exec(e)) ? _n(t[1], t[2] / 100, t[3] / 100, t[4]) : En.hasOwnProperty(e) ? Yn(En[e]) : e === "transparent" ? new K(NaN, NaN, NaN, 0) : null;
}
function Yn(e) {
  return new K(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function nt(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new K(e, t, n, r);
}
function Fi(e) {
  return e instanceof tt || (e = Ge(e)), e ? (e = e.rgb(), new K(e.r, e.g, e.b, e.opacity)) : new K();
}
function Rt(e, t, n, r) {
  return arguments.length === 1 ? Fi(e) : new K(e, t, n, r == null ? 1 : r);
}
function K(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
en(K, Rt, Cr(tt, {
  brighter: function(e) {
    return e = e == null ? lt : Math.pow(lt, e), new K(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Be : Math.pow(Be, e), new K(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Fn,
  formatHex: Fn,
  formatRgb: Wn,
  toString: Wn
}));
function Fn() {
  return "#" + Mt(this.r) + Mt(this.g) + Mt(this.b);
}
function Wn() {
  var e = this.opacity;
  return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
}
function Mt(e) {
  return e = Math.max(0, Math.min(255, Math.round(e) || 0)), (e < 16 ? "0" : "") + e.toString(16);
}
function _n(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new oe(e, t, n, r);
}
function Sr(e) {
  if (e instanceof oe)
    return new oe(e.h, e.s, e.l, e.opacity);
  if (e instanceof tt || (e = Ge(e)), !e)
    return new oe();
  if (e instanceof oe)
    return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, a = Math.min(t, n, r), o = Math.max(t, n, r), i = NaN, u = o - a, c = (o + a) / 2;
  return u ? (t === o ? i = (n - r) / u + (n < r) * 6 : n === o ? i = (r - t) / u + 2 : i = (t - n) / u + 4, u /= c < 0.5 ? o + a : 2 - o - a, i *= 60) : u = c > 0 && c < 1 ? 0 : i, new oe(i, u, c, e.opacity);
}
function Wi(e, t, n, r) {
  return arguments.length === 1 ? Sr(e) : new oe(e, t, n, r == null ? 1 : r);
}
function oe(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
en(oe, Wi, Cr(tt, {
  brighter: function(e) {
    return e = e == null ? lt : Math.pow(lt, e), new oe(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Be : Math.pow(Be, e), new oe(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, a = 2 * n - r;
    return new K(
      Tt(e >= 240 ? e - 240 : e + 120, a, r),
      Tt(e, a, r),
      Tt(e < 120 ? e + 240 : e - 120, a, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var e = this.opacity;
    return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (e === 1 ? ")" : ", " + e + ")");
  }
}));
function Tt(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const tn = (e) => () => e;
function _i(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Pi(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Hi(e) {
  return (e = +e) == 1 ? Dr : function(t, n) {
    return n - t ? Pi(t, n, e) : tn(isNaN(t) ? n : t);
  };
}
function Dr(e, t) {
  var n = t - e;
  return n ? _i(e, n) : tn(isNaN(e) ? t : e);
}
const Pn = function e(t) {
  var n = Hi(t);
  function r(a, o) {
    var i = n((a = Rt(a)).r, (o = Rt(o)).r), u = n(a.g, o.g), c = n(a.b, o.b), s = Dr(a.opacity, o.opacity);
    return function(l) {
      return a.r = i(l), a.g = u(l), a.b = c(l), a.opacity = s(l), a + "";
    };
  }
  return r.gamma = e, r;
}(1);
function $i(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), a;
  return function(o) {
    for (a = 0; a < n; ++a)
      r[a] = e[a] * (1 - o) + t[a] * o;
    return r;
  };
}
function Ai(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Ii(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, a = new Array(r), o = new Array(n), i;
  for (i = 0; i < r; ++i)
    a[i] = nn(e[i], t[i]);
  for (; i < n; ++i)
    o[i] = t[i];
  return function(u) {
    for (i = 0; i < r; ++i)
      o[i] = a[i](u);
    return o;
  };
}
function Li(e, t) {
  var n = new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function ft(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function Ri(e, t) {
  var n = {}, r = {}, a;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (a in t)
    a in e ? n[a] = nn(e[a], t[a]) : r[a] = t[a];
  return function(o) {
    for (a in n)
      r[a] = n[a](o);
    return r;
  };
}
var qt = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Ct = new RegExp(qt.source, "g");
function qi(e) {
  return function() {
    return e;
  };
}
function zi(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Xi(e, t) {
  var n = qt.lastIndex = Ct.lastIndex = 0, r, a, o, i = -1, u = [], c = [];
  for (e = e + "", t = t + ""; (r = qt.exec(e)) && (a = Ct.exec(t)); )
    (o = a.index) > n && (o = t.slice(n, o), u[i] ? u[i] += o : u[++i] = o), (r = r[0]) === (a = a[0]) ? u[i] ? u[i] += a : u[++i] = a : (u[++i] = null, c.push({ i, x: ft(r, a) })), n = Ct.lastIndex;
  return n < t.length && (o = t.slice(n), u[i] ? u[i] += o : u[++i] = o), u.length < 2 ? c[0] ? zi(c[0].x) : qi(t) : (t = c.length, function(s) {
    for (var l = 0, f; l < t; ++l)
      u[(f = c[l]).i] = f.x(s);
    return u.join("");
  });
}
function nn(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? tn(t) : (n === "number" ? ft : n === "string" ? (r = Ge(t)) ? (t = r, Pn) : Xi : t instanceof Ge ? Pn : t instanceof Date ? Li : Ai(t) ? $i : Array.isArray(t) ? Ii : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Ri : ft)(e, t);
}
function ji(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function Vi(e) {
  return function() {
    return e;
  };
}
function Bi(e) {
  return +e;
}
var Hn = [0, 1];
function ie(e) {
  return e;
}
function zt(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Vi(isNaN(t) ? NaN : 0.5);
}
function Qi(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function Gi(e, t, n) {
  var r = e[0], a = e[1], o = t[0], i = t[1];
  return a < r ? (r = zt(a, r), o = n(i, o)) : (r = zt(r, a), o = n(o, i)), function(u) {
    return o(r(u));
  };
}
function Zi(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, a = new Array(r), o = new Array(r), i = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++i < r; )
    a[i] = zt(e[i], e[i + 1]), o[i] = n(t[i], t[i + 1]);
  return function(u) {
    var c = Na(e, u, 1, r) - 1;
    return o[c](a[c](u));
  };
}
function rn(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function kr() {
  var e = Hn, t = Hn, n = nn, r, a, o, i = ie, u, c, s;
  function l() {
    var d = Math.min(e.length, t.length);
    return i !== ie && (i = Qi(e[0], e[d - 1])), u = d > 2 ? Zi : Gi, c = s = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? o : (c || (c = u(e.map(r), t, n)))(r(i(d)));
  }
  return f.invert = function(d) {
    return i(a((s || (s = u(t, e.map(r), ft)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, Bi), l()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), l()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), n = ji, l();
  }, f.clamp = function(d) {
    return arguments.length ? (i = d ? !0 : ie, l()) : i !== ie;
  }, f.interpolate = function(d) {
    return arguments.length ? (n = d, l()) : n;
  }, f.unknown = function(d) {
    return arguments.length ? (o = d, f) : o;
  }, function(d, g) {
    return r = d, a = g, l();
  };
}
function Or() {
  return kr()(ie, ie);
}
function Ji(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function dt(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0)
    return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function Ye(e) {
  return e = dt(Math.abs(e)), e ? e[1] : NaN;
}
function Ki(e, t) {
  return function(n, r) {
    for (var a = n.length, o = [], i = 0, u = e[0], c = 0; a > 0 && u > 0 && (c + u + 1 > r && (u = Math.max(1, r - c)), o.push(n.substring(a -= u, a + u)), !((c += u + 1) > r)); )
      u = e[i = (i + 1) % e.length];
    return o.reverse().join(t);
  };
}
function eu(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var tu = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function ht(e) {
  if (!(t = tu.exec(e)))
    throw new Error("invalid format: " + e);
  var t;
  return new an({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
ht.prototype = an.prototype;
function an(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
an.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function nu(e) {
  e:
    for (var t = e.length, n = 1, r = -1, a; n < t; ++n)
      switch (e[n]) {
        case ".":
          r = a = n;
          break;
        case "0":
          r === 0 && (r = n), a = n;
          break;
        default:
          if (!+e[n])
            break e;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? e.slice(0, r) + e.slice(a + 1) : e;
}
var Er;
function ru(e, t) {
  var n = dt(e, t);
  if (!n)
    return e + "";
  var r = n[0], a = n[1], o = a - (Er = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, i = r.length;
  return o === i ? r : o > i ? r + new Array(o - i + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + dt(e, Math.max(0, t + o - 1))[0];
}
function $n(e, t) {
  var n = dt(e, t);
  if (!n)
    return e + "";
  var r = n[0], a = n[1];
  return a < 0 ? "0." + new Array(-a).join("0") + r : r.length > a + 1 ? r.slice(0, a + 1) + "." + r.slice(a + 1) : r + new Array(a - r.length + 2).join("0");
}
const An = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: Ji,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => $n(e * 100, t),
  r: $n,
  s: ru,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function In(e) {
  return e;
}
var Ln = Array.prototype.map, Rn = ["y", "z", "a", "f", "p", "n", "\xB5", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function au(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? In : Ki(Ln.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", a = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? In : eu(Ln.call(e.numerals, String)), i = e.percent === void 0 ? "%" : e.percent + "", u = e.minus === void 0 ? "\u2212" : e.minus + "", c = e.nan === void 0 ? "NaN" : e.nan + "";
  function s(f) {
    f = ht(f);
    var d = f.fill, g = f.align, v = f.sign, T = f.symbol, y = f.zero, b = f.width, W = f.comma, D = f.precision, p = f.trim, N = f.type;
    N === "n" ? (W = !0, N = "g") : An[N] || (D === void 0 && (D = 12), p = !0, N = "g"), (y || d === "0" && g === "=") && (y = !0, d = "0", g = "=");
    var w = T === "$" ? n : T === "#" && /[boxX]/.test(N) ? "0" + N.toLowerCase() : "", C = T === "$" ? r : /[%p]/.test(N) ? i : "", H = An[N], M = /[defgprs%]/.test(N);
    D = D === void 0 ? 6 : /[gprs]/.test(N) ? Math.max(1, Math.min(21, D)) : Math.max(0, Math.min(20, D));
    function E(S) {
      var Q = w, P = C, L, I, q;
      if (N === "c")
        P = H(S) + P, S = "";
      else {
        S = +S;
        var z = S < 0 || 1 / S < 0;
        if (S = isNaN(S) ? c : H(Math.abs(S), D), p && (S = nu(S)), z && +S == 0 && v !== "+" && (z = !1), Q = (z ? v === "(" ? v : u : v === "-" || v === "(" ? "" : v) + Q, P = (N === "s" ? Rn[8 + Er / 3] : "") + P + (z && v === "(" ? ")" : ""), M) {
          for (L = -1, I = S.length; ++L < I; )
            if (q = S.charCodeAt(L), 48 > q || q > 57) {
              P = (q === 46 ? a + S.slice(L + 1) : S.slice(L)) + P, S = S.slice(0, L);
              break;
            }
        }
      }
      W && !y && (S = t(S, 1 / 0));
      var O = Q.length + S.length + P.length, k = O < b ? new Array(b - O + 1).join(d) : "";
      switch (W && y && (S = t(k + S, k.length ? b - P.length : 1 / 0), k = ""), g) {
        case "<":
          S = Q + S + P + k;
          break;
        case "=":
          S = Q + k + S + P;
          break;
        case "^":
          S = k.slice(0, O = k.length >> 1) + Q + S + P + k.slice(O);
          break;
        default:
          S = k + Q + S + P;
          break;
      }
      return o(S);
    }
    return E.toString = function() {
      return f + "";
    }, E;
  }
  function l(f, d) {
    var g = s((f = ht(f), f.type = "f", f)), v = Math.max(-8, Math.min(8, Math.floor(Ye(d) / 3))) * 3, T = Math.pow(10, -v), y = Rn[8 + v / 3];
    return function(b) {
      return g(T * b) + y;
    };
  }
  return {
    format: s,
    formatPrefix: l
  };
}
var rt, Ur, Nr;
ou({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function ou(e) {
  return rt = au(e), Ur = rt.format, Nr = rt.formatPrefix, rt;
}
function iu(e) {
  return Math.max(0, -Ye(Math.abs(e)));
}
function uu(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Ye(t) / 3))) * 3 - Ye(Math.abs(e)));
}
function su(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Ye(t) - Ye(e)) + 1;
}
function cu(e, t, n, r) {
  var a = It(e, t, n), o;
  switch (r = ht(r == null ? ",f" : r), r.type) {
    case "s": {
      var i = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(o = uu(a, i)) && (r.precision = o), Nr(r, i);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = su(a, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = iu(a)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return Ur(r);
}
function Yr(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return Ia(r[0], r[r.length - 1], n == null ? 10 : n);
  }, e.tickFormat = function(n, r) {
    var a = t();
    return cu(a[0], a[a.length - 1], n == null ? 10 : n, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), a = 0, o = r.length - 1, i = r[a], u = r[o], c, s, l = 10;
    for (u < i && (s = i, i = u, u = s, s = a, a = o, o = s); l-- > 0; ) {
      if (s = hr(i, u, n), s === c)
        return r[a] = i, r[o] = u, t(r);
      if (s > 0)
        i = Math.floor(i / s) * s, u = Math.ceil(u / s) * s;
      else if (s < 0)
        i = Math.ceil(i * s) / s, u = Math.floor(u * s) / s;
      else
        break;
      c = s;
    }
    return e;
  }, e;
}
function on() {
  var e = Or();
  return e.copy = function() {
    return rn(e, on());
  }, et.apply(e, arguments), Yr(e);
}
function lu(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, a = e[n], o = e[r], i;
  return o < a && (i = n, n = r, r = i, i = a, a = o, o = i), e[n] = t.floor(a), e[r] = t.ceil(o), e;
}
function qn(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function fu(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function du(e) {
  return e < 0 ? -e * e : e * e;
}
function hu(e) {
  var t = e(ie, ie), n = 1;
  function r() {
    return n === 1 ? e(ie, ie) : n === 0.5 ? e(fu, du) : e(qn(n), qn(1 / n));
  }
  return t.exponent = function(a) {
    return arguments.length ? (n = +a, r()) : n;
  }, Yr(t);
}
function Fr() {
  var e = hu(kr());
  return e.copy = function() {
    return rn(e, Fr()).exponent(e.exponent());
  }, et.apply(e, arguments), e;
}
function mu() {
  return Fr.apply(null, arguments).exponent(0.5);
}
var St = new Date(), Dt = new Date();
function V(e, t, n, r) {
  function a(o) {
    return e(o = arguments.length === 0 ? new Date() : new Date(+o)), o;
  }
  return a.floor = function(o) {
    return e(o = new Date(+o)), o;
  }, a.ceil = function(o) {
    return e(o = new Date(o - 1)), t(o, 1), e(o), o;
  }, a.round = function(o) {
    var i = a(o), u = a.ceil(o);
    return o - i < u - o ? i : u;
  }, a.offset = function(o, i) {
    return t(o = new Date(+o), i == null ? 1 : Math.floor(i)), o;
  }, a.range = function(o, i, u) {
    var c = [], s;
    if (o = a.ceil(o), u = u == null ? 1 : Math.floor(u), !(o < i) || !(u > 0))
      return c;
    do
      c.push(s = new Date(+o)), t(o, u), e(o);
    while (s < o && o < i);
    return c;
  }, a.filter = function(o) {
    return V(function(i) {
      if (i >= i)
        for (; e(i), !o(i); )
          i.setTime(i - 1);
    }, function(i, u) {
      if (i >= i)
        if (u < 0)
          for (; ++u <= 0; )
            for (; t(i, -1), !o(i); )
              ;
        else
          for (; --u >= 0; )
            for (; t(i, 1), !o(i); )
              ;
    });
  }, n && (a.count = function(o, i) {
    return St.setTime(+o), Dt.setTime(+i), e(St), e(Dt), Math.floor(n(St, Dt));
  }, a.every = function(o) {
    return o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? a.filter(r ? function(i) {
      return r(i) % o === 0;
    } : function(i) {
      return a.count(0, i) % o === 0;
    }) : a;
  }), a;
}
var mt = V(function() {
}, function(e, t) {
  e.setTime(+e + t);
}, function(e, t) {
  return t - e;
});
mt.every = function(e) {
  return e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? V(function(t) {
    t.setTime(Math.floor(t / e) * e);
  }, function(t, n) {
    t.setTime(+t + n * e);
  }, function(t, n) {
    return (n - t) / e;
  }) : mt;
};
const gu = mt;
mt.range;
const se = 1e3, ne = se * 60, ce = ne * 60, Me = ce * 24, un = Me * 7, zn = Me * 30, kt = Me * 365;
var Wr = V(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, t) {
  e.setTime(+e + t * se);
}, function(e, t) {
  return (t - e) / se;
}, function(e) {
  return e.getUTCSeconds();
});
const Ve = Wr;
Wr.range;
var _r = V(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * se);
}, function(e, t) {
  e.setTime(+e + t * ne);
}, function(e, t) {
  return (t - e) / ne;
}, function(e) {
  return e.getMinutes();
});
const Pr = _r;
_r.range;
var Hr = V(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * se - e.getMinutes() * ne);
}, function(e, t) {
  e.setTime(+e + t * ce);
}, function(e, t) {
  return (t - e) / ce;
}, function(e) {
  return e.getHours();
});
const $r = Hr;
Hr.range;
var Ar = V(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * ne) / Me,
  (e) => e.getDate() - 1
);
const Ir = Ar;
Ar.range;
function Te(e) {
  return V(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * ne) / un;
  });
}
var sn = Te(0), vu = Te(1), yu = Te(2), pu = Te(3), wu = Te(4), xu = Te(5), bu = Te(6);
sn.range;
vu.range;
yu.range;
pu.range;
wu.range;
xu.range;
bu.range;
var Lr = V(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
const Rr = Lr;
Lr.range;
var cn = V(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
cn.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : V(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
const qr = cn;
cn.range;
var zr = V(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * ne);
}, function(e, t) {
  return (t - e) / ne;
}, function(e) {
  return e.getUTCMinutes();
});
const Mu = zr;
zr.range;
var Xr = V(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * ce);
}, function(e, t) {
  return (t - e) / ce;
}, function(e) {
  return e.getUTCHours();
});
const Tu = Xr;
Xr.range;
var jr = V(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / Me;
}, function(e) {
  return e.getUTCDate() - 1;
});
const Cu = jr;
jr.range;
function Ce(e) {
  return V(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / un;
  });
}
var Vr = Ce(0), Su = Ce(1), Du = Ce(2), ku = Ce(3), Ou = Ce(4), Eu = Ce(5), Uu = Ce(6);
Vr.range;
Su.range;
Du.range;
ku.range;
Ou.range;
Eu.range;
Uu.range;
var Br = V(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
const Nu = Br;
Br.range;
var ln = V(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
ln.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : V(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
const Yu = ln;
ln.range;
function Qr(e, t, n, r, a, o) {
  const i = [
    [Ve, 1, se],
    [Ve, 5, 5 * se],
    [Ve, 15, 15 * se],
    [Ve, 30, 30 * se],
    [o, 1, ne],
    [o, 5, 5 * ne],
    [o, 15, 15 * ne],
    [o, 30, 30 * ne],
    [a, 1, ce],
    [a, 3, 3 * ce],
    [a, 6, 6 * ce],
    [a, 12, 12 * ce],
    [r, 1, Me],
    [r, 2, 2 * Me],
    [n, 1, un],
    [t, 1, zn],
    [t, 3, 3 * zn],
    [e, 1, kt]
  ];
  function u(s, l, f) {
    const d = l < s;
    d && ([s, l] = [l, s]);
    const g = f && typeof f.range == "function" ? f : c(s, l, f), v = g ? g.range(s, +l + 1) : [];
    return d ? v.reverse() : v;
  }
  function c(s, l, f) {
    const d = Math.abs(l - s) / f, g = Jt(([, , y]) => y).right(i, d);
    if (g === i.length)
      return e.every(It(s / kt, l / kt, f));
    if (g === 0)
      return gu.every(Math.max(It(s, l, f), 1));
    const [v, T] = i[d / i[g - 1][2] < i[g][2] / d ? g - 1 : g];
    return v.every(T);
  }
  return [u, c];
}
Qr(Yu, Nu, Vr, Cu, Tu, Mu);
const [Fu, Wu] = Qr(qr, Rr, sn, Ir, $r, Pr);
var Ot = new Date(), Et = new Date();
function fe(e, t, n, r) {
  function a(o) {
    return e(o = arguments.length === 0 ? new Date() : new Date(+o)), o;
  }
  return a.floor = function(o) {
    return e(o = new Date(+o)), o;
  }, a.ceil = function(o) {
    return e(o = new Date(o - 1)), t(o, 1), e(o), o;
  }, a.round = function(o) {
    var i = a(o), u = a.ceil(o);
    return o - i < u - o ? i : u;
  }, a.offset = function(o, i) {
    return t(o = new Date(+o), i == null ? 1 : Math.floor(i)), o;
  }, a.range = function(o, i, u) {
    var c = [], s;
    if (o = a.ceil(o), u = u == null ? 1 : Math.floor(u), !(o < i) || !(u > 0))
      return c;
    do
      c.push(s = new Date(+o)), t(o, u), e(o);
    while (s < o && o < i);
    return c;
  }, a.filter = function(o) {
    return fe(function(i) {
      if (i >= i)
        for (; e(i), !o(i); )
          i.setTime(i - 1);
    }, function(i, u) {
      if (i >= i)
        if (u < 0)
          for (; ++u <= 0; )
            for (; t(i, -1), !o(i); )
              ;
        else
          for (; --u >= 0; )
            for (; t(i, 1), !o(i); )
              ;
    });
  }, n && (a.count = function(o, i) {
    return Ot.setTime(+o), Et.setTime(+i), e(Ot), e(Et), Math.floor(n(Ot, Et));
  }, a.every = function(o) {
    return o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? a.filter(r ? function(i) {
      return r(i) % o === 0;
    } : function(i) {
      return a.count(0, i) % o === 0;
    }) : a;
  }), a;
}
const _u = 1e3, fn = _u * 60, Pu = fn * 60, dn = Pu * 24, Gr = dn * 7;
var Zr = fe(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * fn) / dn,
  (e) => e.getDate() - 1
);
const Jr = Zr;
Zr.range;
function Se(e) {
  return fe(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * fn) / Gr;
  });
}
var Kr = Se(0), gt = Se(1), Hu = Se(2), $u = Se(3), Fe = Se(4), Au = Se(5), Iu = Se(6);
Kr.range;
gt.range;
Hu.range;
$u.range;
Fe.range;
Au.range;
Iu.range;
var hn = fe(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
hn.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fe(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
const Ze = hn;
hn.range;
var ea = fe(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / dn;
}, function(e) {
  return e.getUTCDate() - 1;
});
const ta = ea;
ea.range;
function De(e) {
  return fe(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / Gr;
  });
}
var na = De(0), vt = De(1), Lu = De(2), Ru = De(3), We = De(4), qu = De(5), zu = De(6);
na.range;
vt.range;
Lu.range;
Ru.range;
We.range;
qu.range;
zu.range;
var mn = fe(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
mn.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : fe(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
const Je = mn;
mn.range;
function Ut(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Nt(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function qe(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function Xu(e) {
  var t = e.dateTime, n = e.date, r = e.time, a = e.periods, o = e.days, i = e.shortDays, u = e.months, c = e.shortMonths, s = ze(a), l = Xe(a), f = ze(o), d = Xe(o), g = ze(i), v = Xe(i), T = ze(u), y = Xe(u), b = ze(c), W = Xe(c), D = {
    a: z,
    A: O,
    b: k,
    B: $e,
    c: null,
    d: Gn,
    e: Gn,
    f: ms,
    g: Cs,
    G: Ds,
    H: fs,
    I: ds,
    j: hs,
    L: ra,
    m: gs,
    M: vs,
    p: Ae,
    q: ve,
    Q: Kn,
    s: er,
    S: ys,
    u: ps,
    U: ws,
    V: xs,
    w: bs,
    W: Ms,
    x: null,
    X: null,
    y: Ts,
    Y: Ss,
    Z: ks,
    "%": Jn
  }, p = {
    a: ye,
    A: ke,
    b: pt,
    B: wt,
    c: null,
    d: Zn,
    e: Zn,
    f: Ns,
    g: Ls,
    G: qs,
    H: Os,
    I: Es,
    j: Us,
    L: oa,
    m: Ys,
    M: Fs,
    p: de,
    q: Ie,
    Q: Kn,
    s: er,
    S: Ws,
    u: _s,
    U: Ps,
    V: Hs,
    w: $s,
    W: As,
    x: null,
    X: null,
    y: Is,
    Y: Rs,
    Z: zs,
    "%": Jn
  }, N = {
    a: E,
    A: S,
    b: Q,
    B: P,
    c: L,
    d: Bn,
    e: Bn,
    f: us,
    g: Vn,
    G: jn,
    H: Qn,
    I: Qn,
    j: rs,
    L: is,
    m: ns,
    M: as,
    p: M,
    q: ts,
    Q: cs,
    s: ls,
    S: os,
    u: Gu,
    U: Zu,
    V: Ju,
    w: Qu,
    W: Ku,
    x: I,
    X: q,
    y: Vn,
    Y: jn,
    Z: es,
    "%": ss
  };
  D.x = w(n, D), D.X = w(r, D), D.c = w(t, D), p.x = w(n, p), p.X = w(r, p), p.c = w(t, p);
  function w(x, U) {
    return function(Y) {
      var m = [], G = -1, A = 0, Z = x.length, J, pe, vn;
      for (Y instanceof Date || (Y = new Date(+Y)); ++G < Z; )
        x.charCodeAt(G) === 37 && (m.push(x.slice(A, G)), (pe = Xn[J = x.charAt(++G)]) != null ? J = x.charAt(++G) : pe = J === "e" ? " " : "0", (vn = U[J]) && (J = vn(Y, pe)), m.push(J), A = G + 1);
      return m.push(x.slice(A, G)), m.join("");
    };
  }
  function C(x, U) {
    return function(Y) {
      var m = qe(1900, void 0, 1), G = H(m, x, Y += "", 0), A, Z;
      if (G != Y.length)
        return null;
      if ("Q" in m)
        return new Date(m.Q);
      if ("s" in m)
        return new Date(m.s * 1e3 + ("L" in m ? m.L : 0));
      if (U && !("Z" in m) && (m.Z = 0), "p" in m && (m.H = m.H % 12 + m.p * 12), m.m === void 0 && (m.m = "q" in m ? m.q : 0), "V" in m) {
        if (m.V < 1 || m.V > 53)
          return null;
        "w" in m || (m.w = 1), "Z" in m ? (A = Nt(qe(m.y, 0, 1)), Z = A.getUTCDay(), A = Z > 4 || Z === 0 ? vt.ceil(A) : vt(A), A = ta.offset(A, (m.V - 1) * 7), m.y = A.getUTCFullYear(), m.m = A.getUTCMonth(), m.d = A.getUTCDate() + (m.w + 6) % 7) : (A = Ut(qe(m.y, 0, 1)), Z = A.getDay(), A = Z > 4 || Z === 0 ? gt.ceil(A) : gt(A), A = Jr.offset(A, (m.V - 1) * 7), m.y = A.getFullYear(), m.m = A.getMonth(), m.d = A.getDate() + (m.w + 6) % 7);
      } else
        ("W" in m || "U" in m) && ("w" in m || (m.w = "u" in m ? m.u % 7 : "W" in m ? 1 : 0), Z = "Z" in m ? Nt(qe(m.y, 0, 1)).getUTCDay() : Ut(qe(m.y, 0, 1)).getDay(), m.m = 0, m.d = "W" in m ? (m.w + 6) % 7 + m.W * 7 - (Z + 5) % 7 : m.w + m.U * 7 - (Z + 6) % 7);
      return "Z" in m ? (m.H += m.Z / 100 | 0, m.M += m.Z % 100, Nt(m)) : Ut(m);
    };
  }
  function H(x, U, Y, m) {
    for (var G = 0, A = U.length, Z = Y.length, J, pe; G < A; ) {
      if (m >= Z)
        return -1;
      if (J = U.charCodeAt(G++), J === 37) {
        if (J = U.charAt(G++), pe = N[J in Xn ? U.charAt(G++) : J], !pe || (m = pe(x, Y, m)) < 0)
          return -1;
      } else if (J != Y.charCodeAt(m++))
        return -1;
    }
    return m;
  }
  function M(x, U, Y) {
    var m = s.exec(U.slice(Y));
    return m ? (x.p = l.get(m[0].toLowerCase()), Y + m[0].length) : -1;
  }
  function E(x, U, Y) {
    var m = g.exec(U.slice(Y));
    return m ? (x.w = v.get(m[0].toLowerCase()), Y + m[0].length) : -1;
  }
  function S(x, U, Y) {
    var m = f.exec(U.slice(Y));
    return m ? (x.w = d.get(m[0].toLowerCase()), Y + m[0].length) : -1;
  }
  function Q(x, U, Y) {
    var m = b.exec(U.slice(Y));
    return m ? (x.m = W.get(m[0].toLowerCase()), Y + m[0].length) : -1;
  }
  function P(x, U, Y) {
    var m = T.exec(U.slice(Y));
    return m ? (x.m = y.get(m[0].toLowerCase()), Y + m[0].length) : -1;
  }
  function L(x, U, Y) {
    return H(x, t, U, Y);
  }
  function I(x, U, Y) {
    return H(x, n, U, Y);
  }
  function q(x, U, Y) {
    return H(x, r, U, Y);
  }
  function z(x) {
    return i[x.getDay()];
  }
  function O(x) {
    return o[x.getDay()];
  }
  function k(x) {
    return c[x.getMonth()];
  }
  function $e(x) {
    return u[x.getMonth()];
  }
  function Ae(x) {
    return a[+(x.getHours() >= 12)];
  }
  function ve(x) {
    return 1 + ~~(x.getMonth() / 3);
  }
  function ye(x) {
    return i[x.getUTCDay()];
  }
  function ke(x) {
    return o[x.getUTCDay()];
  }
  function pt(x) {
    return c[x.getUTCMonth()];
  }
  function wt(x) {
    return u[x.getUTCMonth()];
  }
  function de(x) {
    return a[+(x.getUTCHours() >= 12)];
  }
  function Ie(x) {
    return 1 + ~~(x.getUTCMonth() / 3);
  }
  return {
    format: function(x) {
      var U = w(x += "", D);
      return U.toString = function() {
        return x;
      }, U;
    },
    parse: function(x) {
      var U = C(x += "", !1);
      return U.toString = function() {
        return x;
      }, U;
    },
    utcFormat: function(x) {
      var U = w(x += "", p);
      return U.toString = function() {
        return x;
      }, U;
    },
    utcParse: function(x) {
      var U = C(x += "", !0);
      return U.toString = function() {
        return x;
      }, U;
    }
  };
}
var Xn = { "-": "", _: " ", 0: "0" }, B = /^\s*\d+/, ju = /^%/, Vu = /[\\^$*+?|[\]().{}]/g;
function F(e, t, n) {
  var r = e < 0 ? "-" : "", a = (r ? -e : e) + "", o = a.length;
  return r + (o < n ? new Array(n - o + 1).join(t) + a : a);
}
function Bu(e) {
  return e.replace(Vu, "\\$&");
}
function ze(e) {
  return new RegExp("^(?:" + e.map(Bu).join("|") + ")", "i");
}
function Xe(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function Qu(e, t, n) {
  var r = B.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function Gu(e, t, n) {
  var r = B.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function Zu(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function Ju(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function Ku(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function jn(e, t, n) {
  var r = B.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function Vn(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function es(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function ts(e, t, n) {
  var r = B.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function ns(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function Bn(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function rs(e, t, n) {
  var r = B.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function Qn(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function as(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function os(e, t, n) {
  var r = B.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function is(e, t, n) {
  var r = B.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function us(e, t, n) {
  var r = B.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function ss(e, t, n) {
  var r = ju.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function cs(e, t, n) {
  var r = B.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function ls(e, t, n) {
  var r = B.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function Gn(e, t) {
  return F(e.getDate(), t, 2);
}
function fs(e, t) {
  return F(e.getHours(), t, 2);
}
function ds(e, t) {
  return F(e.getHours() % 12 || 12, t, 2);
}
function hs(e, t) {
  return F(1 + Jr.count(Ze(e), e), t, 3);
}
function ra(e, t) {
  return F(e.getMilliseconds(), t, 3);
}
function ms(e, t) {
  return ra(e, t) + "000";
}
function gs(e, t) {
  return F(e.getMonth() + 1, t, 2);
}
function vs(e, t) {
  return F(e.getMinutes(), t, 2);
}
function ys(e, t) {
  return F(e.getSeconds(), t, 2);
}
function ps(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function ws(e, t) {
  return F(Kr.count(Ze(e) - 1, e), t, 2);
}
function aa(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? Fe(e) : Fe.ceil(e);
}
function xs(e, t) {
  return e = aa(e), F(Fe.count(Ze(e), e) + (Ze(e).getDay() === 4), t, 2);
}
function bs(e) {
  return e.getDay();
}
function Ms(e, t) {
  return F(gt.count(Ze(e) - 1, e), t, 2);
}
function Ts(e, t) {
  return F(e.getFullYear() % 100, t, 2);
}
function Cs(e, t) {
  return e = aa(e), F(e.getFullYear() % 100, t, 2);
}
function Ss(e, t) {
  return F(e.getFullYear() % 1e4, t, 4);
}
function Ds(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? Fe(e) : Fe.ceil(e), F(e.getFullYear() % 1e4, t, 4);
}
function ks(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + F(t / 60 | 0, "0", 2) + F(t % 60, "0", 2);
}
function Zn(e, t) {
  return F(e.getUTCDate(), t, 2);
}
function Os(e, t) {
  return F(e.getUTCHours(), t, 2);
}
function Es(e, t) {
  return F(e.getUTCHours() % 12 || 12, t, 2);
}
function Us(e, t) {
  return F(1 + ta.count(Je(e), e), t, 3);
}
function oa(e, t) {
  return F(e.getUTCMilliseconds(), t, 3);
}
function Ns(e, t) {
  return oa(e, t) + "000";
}
function Ys(e, t) {
  return F(e.getUTCMonth() + 1, t, 2);
}
function Fs(e, t) {
  return F(e.getUTCMinutes(), t, 2);
}
function Ws(e, t) {
  return F(e.getUTCSeconds(), t, 2);
}
function _s(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function Ps(e, t) {
  return F(na.count(Je(e) - 1, e), t, 2);
}
function ia(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? We(e) : We.ceil(e);
}
function Hs(e, t) {
  return e = ia(e), F(We.count(Je(e), e) + (Je(e).getUTCDay() === 4), t, 2);
}
function $s(e) {
  return e.getUTCDay();
}
function As(e, t) {
  return F(vt.count(Je(e) - 1, e), t, 2);
}
function Is(e, t) {
  return F(e.getUTCFullYear() % 100, t, 2);
}
function Ls(e, t) {
  return e = ia(e), F(e.getUTCFullYear() % 100, t, 2);
}
function Rs(e, t) {
  return F(e.getUTCFullYear() % 1e4, t, 4);
}
function qs(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? We(e) : We.ceil(e), F(e.getUTCFullYear() % 1e4, t, 4);
}
function zs() {
  return "+0000";
}
function Jn() {
  return "%";
}
function Kn(e) {
  return +e;
}
function er(e) {
  return Math.floor(+e / 1e3);
}
var Ee, ua;
Xs({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Xs(e) {
  return Ee = Xu(e), ua = Ee.format, Ee.parse, Ee.utcFormat, Ee.utcParse, Ee;
}
function js(e) {
  return new Date(e);
}
function Vs(e) {
  return e instanceof Date ? +e : +new Date(+e);
}
function sa(e, t, n, r, a, o, i, u, c, s) {
  var l = Or(), f = l.invert, d = l.domain, g = s(".%L"), v = s(":%S"), T = s("%I:%M"), y = s("%I %p"), b = s("%a %d"), W = s("%b %d"), D = s("%B"), p = s("%Y");
  function N(w) {
    return (c(w) < w ? g : u(w) < w ? v : i(w) < w ? T : o(w) < w ? y : r(w) < w ? a(w) < w ? b : W : n(w) < w ? D : p)(w);
  }
  return l.invert = function(w) {
    return new Date(f(w));
  }, l.domain = function(w) {
    return arguments.length ? d(Array.from(w, Vs)) : d().map(js);
  }, l.ticks = function(w) {
    var C = d();
    return e(C[0], C[C.length - 1], w == null ? 10 : w);
  }, l.tickFormat = function(w, C) {
    return C == null ? N : s(C);
  }, l.nice = function(w) {
    var C = d();
    return (!w || typeof w.range != "function") && (w = t(C[0], C[C.length - 1], w == null ? 10 : w)), w ? d(lu(C, w)) : l;
  }, l.copy = function() {
    return rn(l, sa(e, t, n, r, a, o, i, u, c, s));
  }, l;
}
function Bs() {
  return et.apply(sa(Fu, Wu, qr, Rr, sn, Ir, $r, Pr, Ve, ua).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
const Qs = (e) => {
  const t = Ra(e, (r) => r.startTimeMillis), n = La(e, (r) => r.endTimeMillis === void 0 ? r.startTimeMillis : r.endTimeMillis);
  return [t != null ? t : NaN, n != null ? n : NaN];
}, Gs = ({
  width: e,
  height: t,
  events: n,
  lanes: r,
  customRange: a,
  zoomLevels: o,
  onZoomRangeChange: i
}) => {
  const u = be(() => a != null ? a : Qs(n), [n, a]), c = u[0], s = u[1], [l, f] = me(u), { currentZoomScale: d, nextSmallerZoomScale: g } = br(l, o);
  ae(() => {
    f([c, s]);
  }, [c, s]), ae(() => {
    i && i(...l);
  }, [l, i]);
  const v = 50, T = be(
    () => on().domain(l).range([v, e - v]),
    [l, e]
  ), y = be(
    () => Tr().domain(r.map((b) => b.laneId)).range([0, t]).paddingInner(0.3).paddingOuter(0.8),
    [r, t]
  );
  return {
    domain: l,
    setDomain: f,
    maxDomain: u,
    maxDomainStart: c,
    maxDomainEnd: s,
    currentZoomScale: d,
    nextSmallerZoomScale: g,
    timeScale: T,
    yScale: y
  };
}, tr = 1e3, Zs = ({
  setDomain: e,
  maxDomainStart: t,
  maxDomainEnd: n
}) => {
  const [r, a] = me("none"), o = Date.now();
  return ae(() => {
    a("none");
  }, [t, n]), ae(() => {
    if (r !== "none") {
      const u = o - r.startMs;
      if (u < tr) {
        const c = u / tr, s = c * (r.toDomain[0] - r.fromDomain[0]), l = c * (r.toDomain[1] - r.fromDomain[1]), f = [r.fromDomain[0] + s, r.fromDomain[1] + l];
        requestAnimationFrame(() => {
          e(f), f[0] === r.toDomain[0] && f[1] === r.toDomain[1] && a("none");
        });
      } else
        e(r.toDomain), a("none");
    }
  }, [r, o, e]), { isAnimationInProgress: r !== "none", setAnimation: a, animation: r };
};
var Yt = new Date(), Ft = new Date();
function ca(e, t, n, r) {
  function a(o) {
    return e(o = arguments.length === 0 ? new Date() : new Date(+o)), o;
  }
  return a.floor = function(o) {
    return e(o = new Date(+o)), o;
  }, a.ceil = function(o) {
    return e(o = new Date(o - 1)), t(o, 1), e(o), o;
  }, a.round = function(o) {
    var i = a(o), u = a.ceil(o);
    return o - i < u - o ? i : u;
  }, a.offset = function(o, i) {
    return t(o = new Date(+o), i == null ? 1 : Math.floor(i)), o;
  }, a.range = function(o, i, u) {
    var c = [], s;
    if (o = a.ceil(o), u = u == null ? 1 : Math.floor(u), !(o < i) || !(u > 0))
      return c;
    do
      c.push(s = new Date(+o)), t(o, u), e(o);
    while (s < o && o < i);
    return c;
  }, a.filter = function(o) {
    return ca(function(i) {
      if (i >= i)
        for (; e(i), !o(i); )
          i.setTime(i - 1);
    }, function(i, u) {
      if (i >= i)
        if (u < 0)
          for (; ++u <= 0; )
            for (; t(i, -1), !o(i); )
              ;
        else
          for (; --u >= 0; )
            for (; t(i, 1), !o(i); )
              ;
    });
  }, n && (a.count = function(o, i) {
    return Yt.setTime(+o), Ft.setTime(+i), e(Yt), e(Ft), Math.floor(n(Yt, Ft));
  }, a.every = function(o) {
    return o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? a.filter(r ? function(i) {
      return r(i) % o === 0;
    } : function(i) {
      return a.count(0, i) % o === 0;
    }) : a;
  }), a;
}
var la = ca(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
const Js = la;
la.range;
const $ = () => {
  const e = ba(Zt);
  return process.env.NODE_ENV !== "production" && Ma(e), e;
}, fa = () => ({
  stroke: $().grid.lineColor
}), Ks = ({
  height: e,
  domain: t,
  smallerZoomScale: n,
  timeScale: r
}) => {
  switch (n) {
    case te.TEN_YEARS:
      return /* @__PURE__ */ h(nr, {
        height: e,
        domain: t,
        timeScale: r,
        showDecadesOnly: !0
      });
    case te.ONE_YEAR:
      return /* @__PURE__ */ h(nr, {
        height: e,
        domain: t,
        timeScale: r
      });
    case te.ONE_MONTH:
      return /* @__PURE__ */ h(rr, {
        height: e,
        domain: t,
        timeScale: r
      });
    default:
      return /* @__PURE__ */ h(rr, {
        height: e,
        domain: t,
        timeScale: r,
        showWeekStripes: !0
      });
  }
}, ec = () => {
  const e = $();
  return {
    fill: e.xAxis.labelColor,
    opacity: 0.5,
    fontFamily: e.base.fontFamilyCaption,
    fontWeight: "bold",
    textAnchor: "middle",
    cursor: "default"
  };
}, nr = ({
  height: e,
  domain: t,
  timeScale: n,
  showDecadesOnly: r = !1
}) => {
  const a = $().xAxis, o = ec(), i = fa(), u = Lt, c = new Date(t[0]).getFullYear(), s = new Date(t[1]).getFullYear(), l = yr(c - 1, s + 2).map((f) => {
    const d = new Date(f, 0, 1).valueOf(), g = n(d), v = n(d + u / 2), T = 2 * (v - g), y = a.yearLabelFontSize ? a.yearLabelFontSize : Math.max(T * 0.1, 14), b = f % 10 === 0;
    return /* @__PURE__ */ X("g", {
      children: [/* @__PURE__ */ h("line", {
        style: i,
        x1: g,
        y1: 0,
        x2: g,
        y2: e
      }), /* @__PURE__ */ h("text", {
        style: o,
        x: v,
        y: "90%",
        fontSize: y,
        writingMode: r ? "vertical-lr" : "horizontal-tb",
        children: r ? b ? f : "" : f
      })]
    }, f);
  });
  return /* @__PURE__ */ h("g", {
    children: l
  });
}, tc = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Xt = 18, nc = () => {
  const e = $();
  return {
    fill: e.xAxis.labelColor,
    opacity: 0.5,
    fontFamily: e.base.fontFamilyCaption,
    fontSize: e.xAxis.monthLabelFontSize ? e.xAxis.monthLabelFontSize : Xt,
    fontWeight: "bold",
    textAnchor: "middle",
    cursor: "default"
  };
}, rr = ({
  height: e,
  domain: t,
  timeScale: n,
  showWeekStripes: r = !1
}) => {
  const a = nc(), o = wr, u = Bs().domain([new Date(t[0]), new Date(t[1])]).ticks(Js.every(1)), c = u.map((s, l) => {
    const f = s.valueOf(), d = s.getMonth(), g = s.getFullYear(), v = n(f), T = n(f + o / 2), y = n(Xa(f, 1)), b = l === u.length - 1;
    return /* @__PURE__ */ X("g", {
      children: [r && /* @__PURE__ */ h(rc, {
        monthStart: f,
        timeScale: n
      }), /* @__PURE__ */ h(ar, {
        x: v,
        month: d
      }), /* @__PURE__ */ h("text", {
        style: a,
        x: T,
        y: e - 1.5 * Xt,
        children: tc[d]
      }), /* @__PURE__ */ h("text", {
        style: a,
        x: T,
        y: e - 0.5 * Xt,
        children: g
      }), b && /* @__PURE__ */ h(ar, {
        x: y,
        month: d
      })]
    }, f);
  });
  return /* @__PURE__ */ h("g", {
    children: c
  });
}, ar = ({
  x: e,
  month: t
}) => {
  const n = fa();
  return /* @__PURE__ */ h("line", {
    style: n,
    x1: e,
    y1: 0,
    x2: e,
    y2: "100%",
    strokeWidth: t === 0 ? 2 : 1
  });
}, rc = ({
  monthStart: e,
  timeScale: t
}) => {
  const n = $().grid, r = Ja(e), a = yr(1, 6).map((o) => {
    const i = Ba(wn(e, o)), u = o;
    if (di(i, r) || fi(i, r)) {
      const c = t(i.valueOf()), s = Ka(wn(e, o)), l = t(s.valueOf()) - c, d = Math.floor(i.valueOf() / pr) % 2 === 0 ? n.weekStripesColor : "transparent", g = n.weekStripesOpacity;
      return /* @__PURE__ */ h("rect", {
        fill: d,
        opacity: g,
        x: c,
        y: 0,
        width: l,
        height: "100%"
      }, u);
    } else
      return /* @__PURE__ */ h("g", {}, u);
  });
  return /* @__PURE__ */ h("g", {
    children: a
  });
};
class ac {
  constructor() {
    xt(this, "canvas");
    xt(this, "canvasContext");
    this.canvas = document.createElement("canvas"), this.canvasContext = this.canvas.getContext("2d");
  }
  getTextWidth(t, n, r = "Helvetica") {
    return this.canvasContext ? (this.canvasContext.font = `${n}px ${r}`, Math.floor(this.canvasContext.measureText(t).width)) : (console.error("Error calculating text string width. Canvas context not created."), 0);
  }
}
const or = new ac();
function oc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ir(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ic(e, t, n) {
  return t && ir(e.prototype, t), n && ir(e, n), e;
}
function uc(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  });
}
function jt(e) {
  return jt = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, jt(e);
}
function sc(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cc(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : sc(e);
}
var lc = function(t, n) {
  if (t.createSVGPoint) {
    var r = t.createSVGPoint();
    return r.x = n.clientX, r.y = n.clientY, r = r.matrixTransform(t.getScreenCTM().inverse()), [r.x, r.y];
  }
  var a = t.getBoundingClientRect();
  return [n.clientX - a.left - t.clientLeft, n.clientY - a.top - t.clientTop];
}, fc = /* @__PURE__ */ function(e) {
  uc(t, e);
  function t() {
    var n;
    return oc(this, t), n = cc(this, jt(t).apply(this, arguments)), n.state = {
      type: "TooltipHidden"
    }, n.updateTooltip = function(r) {
      if (n.props) {
        var a = n.props.containerRef ? n.props.containerRef.current : n.safeMouseTrigger ? n.safeMouseTrigger.ownerSVGElement : void 0;
        if (a) {
          var o = lc(a, r);
          n.setState({
            type: "TooltipVisible",
            svgSvgElement: a,
            x: o[0],
            y: o[1]
          });
        }
      }
    }, n.hideTooltip = function() {
      n.setState({
        type: "TooltipHidden"
      });
    }, n;
  }
  return ic(t, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props.triggerRef.current;
      r && r.addEventListener && (this.safeMouseTrigger = r, r.addEventListener("mouseover", this.updateTooltip), r.addEventListener("mousemove", this.updateTooltip), r.addEventListener("mouseleave", this.hideTooltip));
    }
  }, {
    key: "render",
    value: function() {
      if (this.state.type === "TooltipHidden")
        return yn("g", null);
      var r = this.state.x, a = this.state.y, o = yn("g", {
        className: "Tooltip",
        transform: "translate(".concat(r, ", ").concat(a, ")"),
        pointerEvents: "none"
      }, this.props.children instanceof Function ? this.props.children(r, a) : this.props.children);
      return Sa(o, this.state.svgSvgElement);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.safeMouseTrigger && this.safeMouseTrigger.removeEventListener && (this.safeMouseTrigger.removeEventListener("mouseover", this.updateTooltip), this.safeMouseTrigger.removeEventListener("mousemove", this.updateTooltip), this.safeMouseTrigger.removeEventListener("mouseleave", this.hideTooltip));
    }
  }]), t;
}(Ta);
const dc = () => ({
  textAlign: "left"
}), hc = () => ({
  fill: $().tooltip.backgroundColor,
  strokeWidth: 0
}), mc = () => {
  const e = $().tooltip;
  return {
    fill: "white",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  };
}, gc = ({
  type: e,
  y: t,
  parentWidth: n,
  text: r,
  triggerRef: a
}) => {
  const o = dc(), i = hc(), u = mc(), c = $().tooltip.fontSize, {
    textLines: s,
    tooltipWidth: l,
    tooltipHeight: f,
    baseHeight: d
  } = yc(r, c);
  return /* @__PURE__ */ h(fc, {
    triggerRef: a,
    children: (g, v) => {
      const T = e === "period" ? 0 : e.singleEventX - g, y = 12, b = t - v - f - y, W = t - v - d - y, D = 15, p = on().domain([0, n]).range([D, l - D]), N = 20, w = T - p(g), C = b - N / 2;
      return /* @__PURE__ */ X("g", {
        children: [/* @__PURE__ */ X("svg", {
          style: o,
          x: w,
          y: C,
          width: l,
          height: f,
          children: [/* @__PURE__ */ h("rect", {
            style: i,
            width: "100%",
            height: "100%",
            rx: 3,
            ry: 3
          }), /* @__PURE__ */ h(pc, {
            style: u,
            textLines: s,
            tooltipHeight: f,
            tooltipWidth: l
          })]
        }), /* @__PURE__ */ h(vc, {
          style: i,
          tipX: T,
          baseY: W,
          dimension: N
        }), ")"]
      });
    }
  });
}, vc = ({
  tipX: e,
  baseY: t,
  dimension: n,
  style: r
}) => /* @__PURE__ */ h("svg", {
  x: e - n / 2,
  y: t + n / 2 + 5,
  viewBox: "0 0 10 10",
  width: n,
  height: n,
  children: /* @__PURE__ */ h("path", {
    style: r,
    d: "M0 2.5 l 5 5 5-5z"
  })
}), yc = (e, t) => {
  const n = e || "", r = n.split(`
`), a = r.length, o = a > 1, i = 15, u = 5;
  let c;
  if (o) {
    let f = 0;
    r.forEach((d) => {
      const g = or.getTextWidth(d, t);
      f = Math.max(g, f);
    }), c = f + i * 2;
  } else
    c = or.getTextWidth(n, t) + i * 2;
  const s = 30, l = (o ? 20 * a : s) + u;
  return {
    textLines: r,
    tooltipWidth: c,
    tooltipHeight: l,
    baseHeight: s
  };
}, pc = ({
  textLines: e,
  style: t,
  tooltipWidth: n,
  tooltipHeight: r
}) => /* @__PURE__ */ h("text", {
  style: t,
  width: n,
  height: r,
  children: e.map((a, o) => /* @__PURE__ */ h("tspan", {
    dy: "1.2em",
    x: "10",
    textAnchor: "start",
    children: a
  }, o))
}), wc = () => {
  const e = $().base;
  return {
    strokeWidth: 0,
    fill: e.backgroundColor
  };
}, xc = () => ({
  stroke: $().base.backgroundColor,
  strokeWidth: 2,
  fillOpacity: 0.5
}), bc = () => ({
  stroke: $().base.backgroundColor,
  strokeWidth: 2,
  fillOpacity: 0.5
}), Mc = () => {
  const e = $().event;
  return {
    stroke: e.markSelectedLineColor,
    strokeWidth: 2,
    fill: e.markSelectedFillColor
  };
}, da = (e) => {
  const t = $(), {
    events: n,
    height: r
  } = e, a = wc(), o = bc(), i = xc(), u = Mc(), {
    eventComponent: c,
    timeScale: s,
    y: l
  } = e, f = {
    ...e,
    eventMarkHeight: t.event.markHeight
  }, d = (p) => -(p.endTimeMillis ? p.endTimeMillis - p.startTimeMillis : 0), v = c || ((p, N) => N === "background" ? /* @__PURE__ */ h(at, {
    e: p,
    style: a,
    ...f
  }) : p.isSelected ? /* @__PURE__ */ h(at, {
    e: p,
    style: u,
    ...f
  }) : p.endTimeMillis ? /* @__PURE__ */ h(at, {
    e: p,
    style: o,
    ...f
  }) : /* @__PURE__ */ h(at, {
    e: p,
    style: i,
    ...f
  })), T = JSON.stringify({
    domain: s.domain(),
    range: s.range()
  }), y = JSON.stringify(n, (p, N) => {
    if (!(p === "isSelected" || p === "isPinned"))
      return N;
  }), b = be(
    () => n.map((p) => /* @__PURE__ */ h(Wt, {
      event: p,
      ...e,
      children: v(p, "background", s, l)
    }, p.eventId)),
    [y, T, r, t]
  ), W = be(
    () => n.filter((p) => !0).sort(d).map((p) => /* @__PURE__ */ h(Wt, {
      event: p,
      ...e,
      children: v(p, "foreground", s, l)
    }, p.eventId)),
    [y, T, r, t]
  ), D = be(
    () => n.filter((p) => p.isSelected || p.isPinned).sort(d).map((p) => /* @__PURE__ */ h(Wt, {
      event: p,
      ...e,
      children: v(p, "foreground", s, l)
    }, p.eventId)),
    [n, T, r, t]
  );
  return /* @__PURE__ */ X("g", {
    children: [b, W, D]
  });
}, Wt = ({
  event: e,
  y: t,
  timeScale: n,
  onEventClick: r = Ue,
  onEventHover: a = Ue,
  onEventUnhover: o = Ue,
  children: i
}) => {
  const u = e.eventId, c = () => a(u), s = () => o(u), l = () => r(u), f = n(e.startTimeMillis), d = n.range()[1], g = e.endTimeMillis ? "period" : {
    singleEventX: f
  }, v = fr(null);
  return /* @__PURE__ */ X("g", {
    pointerEvents: "bounding-box",
    cursor: "default",
    onMouseEnter: c,
    onMouseLeave: s,
    onClick: l,
    children: [/* @__PURE__ */ h("g", {
      ref: v,
      children: i
    }), e.tooltip ? /* @__PURE__ */ h(gc, {
      type: g,
      y: t,
      parentWidth: d,
      triggerRef: v,
      text: e.tooltip
    }) : /* @__PURE__ */ h("g", {})]
  });
}, at = ({
  e,
  eventMarkHeight: t,
  style: n,
  y: r,
  timeScale: a
}) => {
  var c, s;
  const o = $(), i = a(e.startTimeMillis), u = e.isPinned ? {
    stroke: o.event.markPinnedLineColor
  } : {};
  if (e.endTimeMillis === void 0)
    return /* @__PURE__ */ h("circle", {
      style: {
        ...n,
        ...u
      },
      cx: i,
      cy: r,
      r: t / 2,
      fill: (c = e.color) != null ? c : o.event.markFillColor
    });
  {
    const f = a(e.endTimeMillis) - i;
    return /* @__PURE__ */ h("rect", {
      style: {
        ...n,
        ...u
      },
      x: i,
      y: r - t / 2,
      width: f,
      height: t,
      fill: (s = e.color) != null ? s : o.event.markFillColor
    });
  }
}, Tc = ({
  height: e,
  events: t,
  lanes: n,
  timeScale: r,
  yScale: a,
  eventComponent: o,
  onEventHover: i,
  onEventUnhover: u,
  onEventClick: c
}) => {
  const s = n.map((l) => {
    const f = t.filter((d) => d.laneId === l.laneId);
    return /* @__PURE__ */ h("g", {
      children: /* @__PURE__ */ h(da, {
        height: e,
        events: f,
        timeScale: r,
        y: a(l.laneId),
        eventComponent: o,
        onEventHover: i,
        onEventUnhover: u,
        onEventClick: c
      })
    }, `marks-${l.laneId}`);
  });
  return /* @__PURE__ */ h("g", {
    children: s
  });
}, _t = {
  x: NaN,
  y: NaN
}, Cc = ({
  width: e,
  height: t,
  children: n
}) => {
  const r = fr(null), [a, o] = me(_t), i = (s) => {
    const l = r.current.getScreenCTM();
    return l ? {
      x: (s.clientX - l.e) / l.a,
      y: (s.clientY - l.f) / l.d
    } : _t;
  }, u = (s) => o(i(s)), c = () => o(_t);
  return /* @__PURE__ */ X("svg", {
    viewBox: `0 0 ${e} ${t}`,
    width: e,
    height: t,
    ref: r,
    style: {
      overflow: "visible"
    },
    onMouseEnter: u,
    onMouseMove: u,
    onMouseLeave: c,
    children: [/* @__PURE__ */ h("rect", {
      width: e,
      height: t,
      pointerEvents: "all",
      fill: "transparent"
    }), n(a)]
  });
}, Sc = (e) => {
  const t = $();
  return {
    fill: e != null ? e : t.mouseCursor.labelColor,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: t.base.fontFamilyCaption,
    cursor: "default"
  };
}, ha = ({
  x: e,
  y: t,
  overline: n,
  label: r,
  cursor: a,
  fill: o
}) => {
  const i = Sc(o);
  return /* @__PURE__ */ X("text", {
    style: i,
    x: e,
    y: t,
    cursor: a,
    children: [/* @__PURE__ */ h("tspan", {
      x: e,
      cursor: a,
      children: n
    }), /* @__PURE__ */ h("tspan", {
      x: e,
      dy: 18,
      cursor: a,
      children: r
    })]
  });
}, gn = () => {
  const e = $().mouseCursor;
  return {
    stroke: e.lineColor,
    strokeWidth: e.lineWidth
  };
}, ma = () => {
  const e = $().mouseCursor;
  return {
    fill: e.zoomRangeColor,
    opacity: e.zoomRangeOpacity
  };
}, Dc = ({
  mousePosition: e,
  cursorLabel: t,
  cursor: n,
  interactionMode: r,
  zoomRangeStart: a,
  zoomRangeEnd: o,
  zoomScale: i,
  isZoomInPossible: u
}) => isNaN(e) ? /* @__PURE__ */ h("g", {}) : /* @__PURE__ */ X("g", {
  children: [/* @__PURE__ */ h("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  }), (() => {
    switch (r.type) {
      case "animation in progress":
        return /* @__PURE__ */ h("g", {});
      case "panning":
        return /* @__PURE__ */ h(Oc, {
          mousePosition: e
        });
      case "rubber band": {
        const [s, l] = r.variant === "anchored" ? [r.anchorX, void 0] : [r.anchorX, r.currentX];
        return /* @__PURE__ */ h(Ec, {
          start: s,
          end: l
        });
      }
      default:
        return /* @__PURE__ */ h(kc, {
          mousePosition: e,
          cursor: n,
          cursorLabel: t,
          zoomScale: i,
          isZoomInPossible: u,
          zoomRangeStart: a,
          zoomRangeEnd: o
        });
    }
  })()]
}), kc = ({
  mousePosition: e,
  cursor: t,
  cursorLabel: n,
  zoomScale: r,
  isZoomInPossible: a,
  zoomRangeStart: o,
  zoomRangeEnd: i
}) => {
  const u = gn(), c = ma();
  return /* @__PURE__ */ X("g", {
    children: [/* @__PURE__ */ h("rect", {
      visibility: a ? "visible" : "hidden",
      style: c,
      x: o,
      y: 0,
      width: i - o,
      height: "100%",
      cursor: t
    }), /* @__PURE__ */ h("line", {
      style: u,
      x1: e,
      y1: "0%",
      x2: e,
      y2: "5%",
      cursor: t
    }), /* @__PURE__ */ h(ha, {
      x: e,
      y: a ? "11%" : "15%",
      cursor: t,
      overline: n,
      label: a ? r : ""
    }), /* @__PURE__ */ h("line", {
      style: u,
      x1: e,
      y1: "23%",
      x2: e,
      y2: "100%",
      cursor: t
    })]
  });
}, Oc = ({
  mousePosition: e
}) => {
  const t = gn();
  return /* @__PURE__ */ h("g", {
    children: /* @__PURE__ */ h("line", {
      style: t,
      x1: e,
      y1: "0%",
      x2: e,
      y2: "100%",
      cursor: "grab"
    })
  });
}, Ec = ({
  start: e,
  end: t
}) => {
  const n = gn(), r = ma(), [a, o] = ["0%", "100%"];
  return /* @__PURE__ */ X("g", {
    children: [/* @__PURE__ */ h("line", {
      style: n,
      x1: e,
      y1: a,
      x2: e,
      y2: o
    }), t && /* @__PURE__ */ X("g", {
      children: [/* @__PURE__ */ h("line", {
        style: n,
        x1: t,
        y1: a,
        x2: t,
        y2: o
      }), /* @__PURE__ */ h("rect", {
        style: r,
        x: Math.min(e, t),
        y: a,
        width: Math.abs(t - e),
        height: o
      })]
    })]
  });
}, Uc = ({
  domain: e,
  maxDomainStart: t,
  maxDomainEnd: n,
  zoomLevels: r,
  isDomainChangePossible: a,
  timeScale: o,
  onDomainChange: i,
  onCursorMove: u
}) => {
  const { currentZoomScale: c, nextSmallerZoomScale: s, nextBiggerZoomScale: l } = br(e, r), f = le(s), d = e[1] - e[0], g = n - t, v = s !== "minimum", T = d < g, y = ee((C) => i(C, !0), [i]), b = ee(
    (C) => (H) => {
      if (a) {
        const M = le(C);
        y(
          xr(t, n, H != null ? H : (e[0] + e[1]) / 2, M)
        );
      }
    },
    [a, t, n, y, e]
  ), W = ee(
    (C) => b(s)(C),
    [s, b]
  ), D = ee(
    (C) => b(l)(C),
    [l, b]
  ), p = ee(
    (C, H) => {
      if (a) {
        const M = o.invert(C), E = o.invert(H);
        y([M, E]);
      }
    },
    [a, y, o]
  ), N = ee(
    (C, H) => {
      if (a && u) {
        const M = o.invert(C), E = o.invert(H);
        u(E, M, E);
      }
    },
    [a, u, o]
  ), w = ee(() => {
    a && y([t, n]);
  }, [a, y, t, n]);
  return {
    currentZoomScale: c,
    zoomWidth: f,
    nextSmallerZoomScale: s,
    nextBiggerZoomScale: l,
    isZoomInPossible: v,
    isZoomOutPossible: T,
    onZoomIn: W,
    onZoomOut: D,
    onZoomReset: w,
    onZoomInCustom: p,
    onZoomInCustomInProgress: N
  };
}, ur = { type: "none" }, ot = { type: "hover" }, Nc = { type: "animation in progress" }, Yc = ({
  width: e,
  height: t,
  mousePosition: n,
  isAnimationInProgress: r,
  isZoomInPossible: a,
  isZoomOutPossible: o,
  isTrimming: i,
  onHover: u,
  onZoomIn: c,
  onZoomOut: s,
  onZoomInCustom: l,
  onZoomInCustomInProgress: f,
  onZoomReset: d,
  onTrimStart: g,
  onTrimEnd: v,
  onPan: T,
  onInteractionModeChange: y,
  onInteractionEnd: b,
  children: W
}) => {
  const [D, p] = me("default"), [N, w] = me(!1), [C, H] = me(!1), [M, E] = me(ur);
  ae(() => {
    if (r)
      return E(Nc), () => {
        E(ot);
      };
  }, [r]), ae(() => {
    const O = (k) => {
      w(k.altKey), H(k.shiftKey), k.key === "Escape" && d();
    };
    return window.addEventListener("keydown", O), window.addEventListener("keyup", O), () => {
      window.removeEventListener("keydown", O), window.removeEventListener("keyup", O);
    };
  }, [w, H, d]), ae(() => {
    if (i && !r)
      return E({
        type: "trim",
        variant: "none"
      }), () => {
        E(ot);
      };
  }, [i, r, E]), ae(() => {
    M.type === "animation in progress" ? p("default") : C || M.type === "rubber band" ? p("ew-resize") : M.type === "panning" ? p("grab") : M.type === "trim" ? M.variant !== "none" ? p("ew-resize") : p("default") : p(N ? (() => o ? "zoom-out" : "default")() : (() => a ? "zoom-in" : "default")());
  }, [N, C, a, o, M]), ae(() => {
    y && y(M);
  }, [y, M]), ae(() => {
    M.type === "none" && b && b();
  }, [b, M]);
  const S = (O, k) => [Math.min(O, k), Math.max(O, k)];
  return /* @__PURE__ */ X(Gt, {
    children: [/* @__PURE__ */ h("defs", {
      children: /* @__PURE__ */ h("clipPath", {
        id: "clipPath",
        children: /* @__PURE__ */ h("rect", {
          x: "0",
          y: "0",
          width: e,
          height: t
        })
      })
    }), /* @__PURE__ */ h("g", {
      clipPath: "url(#clipPath)",
      pointerEvents: "bounding-box",
      cursor: D,
      onMouseDown: () => {
        const O = {
          variant: "anchored",
          anchorX: n.x
        };
        M.type === "trim" ? C ? (g(n.x), E({
          type: "trim",
          variant: "trim pan end"
        })) : M.variant === "trim hover start" ? E({
          type: "trim",
          variant: "trim start"
        }) : M.variant === "trim hover end" && E({
          type: "trim",
          variant: "trim end"
        }) : C ? (E({
          type: "rubber band",
          ...O
        }), f(...S(O.anchorX, O.anchorX))) : E({
          type: "grabbing",
          ...O
        });
      },
      onMouseMove: (O) => {
        if (M.type === "grabbing" && Math.abs(M.anchorX - n.x) > 2 && E((k) => ({
          ...k,
          type: "panning"
        })), M.type === "panning" && T(-O.movementX), M.type === "rubber band") {
          const k = {
            ...M,
            variant: "in progress",
            currentX: n.x
          };
          E(k), f(...S(k.anchorX, k.currentX));
        }
        M.type === "trim" && (M.variant === "trim start" ? g(n.x) : (M.variant === "trim end" || M.variant === "trim pan end") && v(n.x)), M.type === "hover" && u(n.x);
      },
      onMouseUp: (O) => {
        const k = O.button === 0 && M.type === "grabbing";
        M.type === "rubber band" ? l(...S(M.anchorX, n.x)) : k && (O.altKey ? s() : a ? c() : Ue()), M.type === "trim" ? E({
          type: "trim",
          variant: "none"
        }) : E(ot);
      },
      onMouseEnter: () => {
        M.type === "none" && E(ot);
      },
      onMouseLeave: () => {
        (M.type === "hover" || M.type === "panning") && E(ur);
      },
      children: W(D, M, (O) => E((k) => k.type === "trim" && k.variant !== "trim start" && k.variant !== "trim end" && k.variant !== "trim pan end" ? {
        type: "trim",
        ...O
      } : k))
    })]
  });
};
function Fc(e, t, n, r) {
  const a = ee((i) => {
    n && n(t.invert(i), r ? r[1] : e[1]);
  }, [r, e, n, t]), o = ee((i) => {
    n && n(r ? r[0] : e[0], t.invert(i));
  }, [r, e, n, t]);
  return ae(() => {
    if (n && r) {
      const [i, u] = [Sn(r[0], e[0], r[1]), Sn(r[1], r[0], e[1])];
      (i !== r[0] || u !== r[1]) && n(i, u);
    }
  }, [e, r, n]), [a, o];
}
const Wc = () => {
  const e = $().trimmer;
  return {
    fill: e.trimRangeOutsideColor,
    opacity: e.trimRangeOutsideOpacity
  };
};
function _c({
  startX: e,
  endX: t,
  height: n,
  width: r
}) {
  const a = Wc(), [o, i] = [0, n];
  return /* @__PURE__ */ X("g", {
    children: [e > 0 && /* @__PURE__ */ h("rect", {
      style: a,
      x: 0,
      y: o,
      width: e,
      height: i
    }), r - t > 0 && /* @__PURE__ */ h("rect", {
      style: a,
      x: t,
      y: o,
      width: r - t,
      height: i
    })]
  });
}
const Pc = () => {
  const e = $().trimmer;
  return {
    stroke: e.trimHandleColor,
    strokeWidth: e.trimHandleWidth
  };
};
function sr({
  x: e,
  label: t,
  dateString: n,
  height: r,
  onMouseEnter: a,
  onMouseLeave: o
}) {
  const i = $().trimmer, u = Pc();
  return /* @__PURE__ */ X(Gt, {
    children: [/* @__PURE__ */ h("line", {
      style: u,
      pointerEvents: "visibleStroke",
      x1: e,
      y1: 0,
      x2: e,
      y2: "5%",
      onMouseEnter: a,
      onMouseLeave: o
    }), /* @__PURE__ */ h(ha, {
      x: e,
      y: "11%",
      cursor: "default",
      overline: t,
      label: n,
      fill: i.trimHandleLabelColor
    }), /* @__PURE__ */ h("line", {
      style: u,
      x1: e,
      y1: "23%",
      x2: e,
      y2: r,
      onMouseEnter: a,
      onMouseLeave: o,
      pointerEvents: "visibleStroke"
    })]
  });
}
var Vt = /* @__PURE__ */ ((e) => (e[e.Up = 0] = "Up", e[e.Down = 1] = "Down", e[e.Left = 2] = "Left", e[e.Right = 3] = "Right", e))(Vt || {});
function cr({
  style: e,
  x: t,
  y: n,
  dimension: r,
  direction: a
}) {
  let o;
  switch (a) {
    case 2:
      o = "M7.5 0 l -5 5 5 5z";
      break;
    case 3:
      o = "M2.5 0 l 5 5 -5 5z";
      break;
    case 0:
      o = "M0 7.5 l 5 -5 5 5z";
      break;
    case 1:
    default:
      o = "M0 2.5 l 5 5 5-5z";
  }
  return /* @__PURE__ */ h("svg", {
    x: t - r / 2,
    y: n - r / 2,
    viewBox: "0 0 10 10",
    width: r,
    height: r,
    children: /* @__PURE__ */ h("path", {
      style: e,
      d: o
    })
  });
}
const Hc = () => {
  const e = $().trimmer;
  return {
    fill: e.trimRangeInsideColor,
    opacity: e.trimRangeInsideOpacity
  };
}, $c = () => {
  const e = $().trimmer;
  return {
    fill: e.trimRangeInsideHighlightColor,
    opacity: e.trimRangeInsideHighlightOpacity
  };
}, Ac = () => ({
  fill: $().trimmer.trimTriangleColor
});
function Ic({
  startX: e,
  endX: t,
  timeScale: n,
  height: r,
  width: a,
  highlightActiveArea: o,
  setTrimMode: i,
  dateFormat: u
}) {
  const c = Hc(), s = $c(), l = Ac(), [f, d] = [0, r], [g, v] = [n(e), n(t)];
  return /* @__PURE__ */ X("g", {
    children: [/* @__PURE__ */ h("rect", {
      style: o ? s : c,
      x: Math.min(g, v),
      y: f,
      width: Math.abs(v - g),
      height: d
    }), g > 0 ? /* @__PURE__ */ h(sr, {
      x: g,
      dateString: u(e),
      label: "Date from",
      height: r,
      onMouseEnter: () => i({
        variant: "trim hover start"
      }),
      onMouseLeave: () => i({
        variant: "none"
      })
    }) : /* @__PURE__ */ h(cr, {
      style: l,
      x: 25,
      y: r / 2,
      dimension: 50,
      direction: Vt.Left
    }), a - v > 0 ? /* @__PURE__ */ h(sr, {
      x: v,
      dateString: u(t),
      label: "Date to",
      height: r,
      onMouseEnter: () => i({
        variant: "trim hover end"
      }),
      onMouseLeave: () => i({
        variant: "none"
      })
    }) : /* @__PURE__ */ h(cr, {
      style: l,
      x: a - 25,
      y: r / 2,
      dimension: 50,
      direction: Vt.Right
    })]
  });
}
const Lc = ({
  width: e,
  height: t,
  domain: n,
  maxDomain: r,
  maxDomainStart: a,
  maxDomainEnd: o,
  isDomainChangePossible: i,
  timeScale: u,
  zoomLevels: c,
  isTrimming: s,
  trimRange: l,
  isAnimationInProgress: f,
  isNoEventSelected: d,
  onDomainChange: g,
  dateFormat: v,
  onCursorMove: T,
  onTrimRangeChange: y,
  onInteractionEnd: b
}) => {
  const {
    zoomWidth: W,
    nextSmallerZoomScale: D,
    isZoomInPossible: p,
    isZoomOutPossible: N,
    onZoomIn: w,
    onZoomOut: C,
    onZoomReset: H,
    onZoomInCustom: M,
    onZoomInCustomInProgress: E
  } = Uc({
    domain: n,
    maxDomainStart: a,
    maxDomainEnd: o,
    zoomLevels: c,
    isDomainChangePossible: i,
    timeScale: u,
    onDomainChange: g,
    onCursorMove: T
  }), [S, Q] = Fc(r, u, y, l);
  return /* @__PURE__ */ h(Cc, {
    width: e,
    height: t,
    children: (P) => {
      const L = u.invert(P.x);
      return /* @__PURE__ */ h(Yc, {
        width: e,
        height: t,
        mousePosition: P,
        isAnimationInProgress: f,
        isZoomInPossible: p,
        isZoomOutPossible: N,
        isTrimming: s,
        onHover: () => {
          T && T(L, ...xr(a, o, L, W));
        },
        onZoomIn: () => {
          w(L);
        },
        onZoomOut: () => {
          C(L);
        },
        onZoomInCustom: M,
        onZoomInCustomInProgress: E,
        onZoomReset: H,
        onPan: (z) => {
          if (i) {
            const [O, k] = n, [$e, Ae] = u.range(), ve = z / (Ae - $e) * (k - O), [ye, ke] = [O + ve, k + ve];
            ye > a && ke < o && g([ye, ke], !1);
          }
        },
        onTrimStart: S,
        onTrimEnd: Q,
        onInteractionEnd: b,
        children: (z, O, k) => /* @__PURE__ */ X("g", {
          children: [d && O.type !== "trim" ? /* @__PURE__ */ h(Dc, {
            mousePosition: P.x,
            cursorLabel: v(L),
            cursor: z,
            interactionMode: O,
            zoomRangeStart: u(L - W / 2),
            zoomRangeEnd: u(L + W / 2),
            zoomScale: D,
            isZoomInPossible: p
          }) : /* @__PURE__ */ h("g", {}), l && /* @__PURE__ */ h(_c, {
            startX: u(l[0]),
            endX: u(l[1]),
            height: t,
            width: e
          }), O.type === "trim" && u && /* @__PURE__ */ h(Ic, {
            startX: l ? l[0] : r[0],
            endX: l ? l[1] : r[1],
            height: t,
            width: e,
            timeScale: u,
            setTrimMode: k,
            dateFormat: v,
            highlightActiveArea: O.variant === "trim pan end"
          })]
        })
      });
    }
  });
}, Rc = ({
  height: e,
  events: t,
  timeScale: n,
  eventComponent: r,
  onEventHover: a,
  onEventUnhover: o,
  onEventClick: i
}) => {
  const u = e / 2;
  return /* @__PURE__ */ h("g", {
    children: /* @__PURE__ */ h(da, {
      height: e,
      events: t,
      timeScale: n,
      y: u,
      eventComponent: r,
      onEventHover: a,
      onEventUnhover: o,
      onEventClick: i
    })
  });
}, qc = () => ({
  stroke: $().base.backgroundColor,
  strokeWidth: 2,
  fillOpacity: 0.5
}), zc = ({
  eventClusters: e,
  timeScale: t,
  yScale: n,
  expanded: r,
  height: a
}) => {
  const o = $(), i = qc(), [u, c] = Ya(e.map((d) => d.size)), s = o.event.markHeight / 2, l = r ? n.bandwidth() / 1.2 : Math.min(a / 2, 2 * o.event.markHeight), f = mu().domain([u != null ? u : 0, c != null ? c : 0]).range([s, l]);
  return /* @__PURE__ */ h("g", {
    children: e.map((d) => /* @__PURE__ */ h("g", {
      children: /* @__PURE__ */ h("circle", {
        style: i,
        cx: t(d.timeMillis),
        cy: r ? n(d.laneId) : a / 2,
        r: f(d.size),
        fill: d.color || o.event.clusterFillColor
      })
    }, `eventCluster-${d.laneId}-${d.timeMillis}`))
  });
}, ga = ({
  y: e
}) => {
  const t = $();
  return /* @__PURE__ */ h("line", {
    x1: 0,
    y1: e,
    x2: "100%",
    y2: e,
    style: {
      stroke: t.lane.middleLineColor,
      strokeWidth: t.lane.middleLineWidth
    }
  });
}, Xc = ({
  lanes: e,
  yScale: t
}) => {
  const n = $(), r = 0.8 * t.bandwidth();
  return /* @__PURE__ */ h(Gt, {
    children: e.map((a) => {
      const i = -0.5 * t.bandwidth(), u = t(a.laneId);
      return /* @__PURE__ */ X("g", {
        children: [/* @__PURE__ */ h(ga, {
          y: u
        }), /* @__PURE__ */ h("text", {
          style: {
            fontSize: n.lane.labelFontSize,
            fontFamily: n.base.fontFamily,
            fontWeight: 600,
            opacity: 0.4
          },
          fontSize: r,
          x: 10,
          y: u + i,
          fill: a.color || n.lane.labelColor,
          children: a.label
        })]
      }, `axis-${a.laneId}`);
    })
  });
};
var _e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, va = {}, Bt = _e && _e.__assign || function() {
  return Bt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Bt.apply(this, arguments);
}, jc = _e && _e.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, o = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      o.push(a.value);
  } catch (u) {
    i = { error: u };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return o;
}, Vc = _e && _e.__spreadArray || function(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, o; r < a; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
};
Object.defineProperty(va, "__esModule", { value: !0 });
var lr = function(e) {
  if (typeof e == "object" && e !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      var t = Object.getPrototypeOf(e);
      return t === Object.prototype || t === null;
    }
    return Object.prototype.toString.call(e) === "[object Object]";
  }
  return !1;
}, ge = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.reduce(function(n, r) {
    if (Array.isArray(r))
      throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
    return Object.keys(r).forEach(function(a) {
      ["__proto__", "constructor", "prototype"].includes(a) || (Array.isArray(n[a]) && Array.isArray(r[a]) ? n[a] = ge.options.mergeArrays ? Array.from(new Set(n[a].concat(r[a]))) : r[a] : lr(n[a]) && lr(r[a]) ? n[a] = ge(n[a], r[a]) : n[a] = r[a]);
    }), n;
  }, {});
}, ya = {
  mergeArrays: !0
};
ge.options = ya;
ge.withOptions = function(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  ge.options = Bt({ mergeArrays: !0 }, e);
  var r = ge.apply(void 0, Vc([], jc(t), !1));
  return ge.options = ya, r;
};
var Bc = va.default = ge;
const we = "#ffab40", Qc = "#aaaaaa", Qt = "#9e9e9e", Gc = "#eeeeee", Pt = 0.1, Zc = {
  palette: {
    primary: {
      main: "#1976d2"
    },
    background: {
      paper: "#fff"
    },
    text: {
      secondary: Qt
    }
  },
  typography: {
    fontFamily: "sans-serif",
    caption: {}
  }
}, Jc = (e) => Kc("light", Zc, e), Kc = (e, t, n) => {
  const r = {
    base: {
      backgroundColor: t.palette.background.paper,
      fontFamily: t.typography.fontFamily,
      fontFamilyCaption: t.typography.caption.fontFamily
    },
    event: {
      markHeight: 20,
      markFillColor: t.palette.primary.main,
      markSelectedLineColor: "#ffff8d",
      markSelectedFillColor: "rgba(255, 255, 141, 0.5)",
      markPinnedLineColor: e === "dark" ? "white" : "black",
      clusterFillColor: t.palette.primary.main
    },
    xAxis: {
      labelColor: t.palette.text.secondary
    },
    grid: {
      lineColor: Qt,
      weekStripesColor: Gc,
      weekStripesOpacity: e === "light" ? 1 : 0.1
    },
    lane: {
      labelFontSize: 16,
      labelColor: t.palette.primary.main,
      middleLineColor: Qt,
      middleLineWidth: 1
    },
    tooltip: {
      backgroundColor: t.palette.text.secondary,
      fontSize: 14,
      fontFamily: t.typography.caption.fontFamily
    },
    trimmer: {
      trimHandleColor: we,
      trimHandleLabelColor: we,
      trimHandleWidth: 10,
      trimTriangleColor: we,
      trimRangeInsideColor: "transparent",
      trimRangeInsideOpacity: 0,
      trimRangeInsideHighlightColor: we,
      trimRangeInsideHighlightOpacity: Pt,
      trimRangeOutsideColor: Qc,
      trimRangeOutsideOpacity: Pt
    },
    mouseCursor: {
      lineColor: we,
      lineWidth: 2,
      zoomRangeColor: we,
      zoomRangeOpacity: Pt,
      labelColor: we
    }
  };
  return n ? Bc(r, n) : r;
}, al = ({
  width: e,
  height: t,
  events: n,
  lanes: r,
  dateFormat: a,
  eventComponent: o,
  laneDisplayMode: i = "expanded",
  suppressMarkAnimation: u = !1,
  enableEventClustering: c = !1,
  customRange: s,
  zoomLevels: l = xi,
  isTrimming: f = !1,
  trimRange: d,
  layers: g = ["grid", "axes", "interaction", "marks"],
  theme: v = Jc(),
  onEventHover: T = Ue,
  onEventUnhover: y = Ue,
  onEventClick: b,
  onZoomRangeChange: W,
  onCursorMove: D,
  onTrimRangeChange: p,
  onInteractionEnd: N
}) => {
  const {
    domain: w,
    setDomain: C,
    maxDomain: H,
    maxDomainStart: M,
    maxDomainEnd: E,
    currentZoomScale: S,
    nextSmallerZoomScale: Q,
    timeScale: P,
    yScale: L
  } = Gs({
    width: e,
    height: t,
    events: n,
    lanes: r,
    zoomLevels: l,
    customRange: s,
    onZoomRangeChange: W
  }), {
    isAnimationInProgress: I,
    setAnimation: q,
    animation: z
  } = Zs({
    maxDomainStart: M,
    maxDomainEnd: E,
    setDomain: C
  }), {
    eventsInsideDomain: O,
    eventClustersInsideDomain: k,
    isNoEventSelected: $e,
    isMouseOverEvent: Ae,
    onEventHoverDecorated: ve,
    onEventUnhoverDecorated: ye
  } = Ci(n, z !== "none" ? z.fromDomain : w, S, i === "expanded", c, T, y), ke = u ? !I : !0, pt = ee((de, Ie) => {
    Ie ? q({
      startMs: Date.now(),
      fromDomain: w,
      toDomain: de
    }) : C(de);
  }, [w, q, C]), wt = {
    grid: /* @__PURE__ */ h(Ks, {
      height: t,
      domain: w,
      smallerZoomScale: Q,
      timeScale: P
    }, "grid"),
    axes: i === "expanded" ? /* @__PURE__ */ h(Xc, {
      lanes: r,
      yScale: L
    }, "axes") : /* @__PURE__ */ h(ga, {
      y: t / 2
    }, "axis"),
    interaction: /* @__PURE__ */ h(Lc, {
      width: e,
      height: t,
      domain: w,
      maxDomain: H,
      maxDomainStart: M,
      maxDomainEnd: E,
      isDomainChangePossible: !I && !Ae,
      timeScale: P,
      zoomLevels: l,
      isTrimming: f,
      trimRange: d,
      isAnimationInProgress: I,
      isNoEventSelected: $e,
      onDomainChange: pt,
      dateFormat: a,
      onCursorMove: D,
      onInteractionEnd: N,
      onTrimRangeChange: p
    }, "interaction"),
    marks: ke && /* @__PURE__ */ X("g", {
      children: [/* @__PURE__ */ h(zc, {
        height: t,
        eventClusters: k,
        timeScale: P,
        yScale: L,
        expanded: i === "expanded"
      }), i === "expanded" ? /* @__PURE__ */ h(Tc, {
        events: O,
        lanes: r,
        timeScale: P,
        yScale: L,
        height: t,
        eventComponent: o,
        onEventHover: ve,
        onEventUnhover: ye,
        onEventClick: b
      }) : /* @__PURE__ */ h(Rc, {
        events: O,
        timeScale: P,
        height: t,
        eventComponent: o,
        onEventHover: ve,
        onEventUnhover: ye,
        onEventClick: b
      })]
    }, "marks")
  };
  return /* @__PURE__ */ h(Da, {
    theme: v,
    children: /* @__PURE__ */ h("svg", {
      viewBox: `0 0 ${e} ${t}`,
      width: e,
      height: t,
      children: g.map((de, Ie) => typeof de != "function" ? wt[de] : /* @__PURE__ */ h(Ca, {
        children: de({
          width: e,
          height: t,
          domain: w,
          maxDomain: H,
          maxDomainStart: M,
          maxDomainEnd: E,
          currentZoomScale: S,
          nextSmallerZoomScale: Q,
          xScale: P,
          yScale: L,
          events: O,
          eventClusters: k,
          lanes: r,
          laneDisplayMode: i,
          isAnimationInProgress: I
        })
      }, Ie))
    })
  });
};
export {
  Lc as Interaction,
  da as Marks,
  al as Timeline,
  te as ZoomLevels,
  Jc as createTimelineTheme,
  bi as currentZoomScale,
  yt as dayDuration,
  xi as defaultOrderedZoomLevels,
  Kc as deriveTimelineTheme,
  gi as fifteenMins,
  hi as fiveMins,
  xr as getDomainSpan,
  vi as halfHour,
  Nc as interactionModeAnimationInProgress,
  ot as interactionModeHover,
  ur as interactionModeNone,
  wr as monthDuration,
  Ti as nextBiggerZoomScale,
  Mi as nextSmallerZoomScale,
  Ke as oneHour,
  He as oneMin,
  je as oneSec,
  pi as sixHours,
  mi as tenMins,
  yi as threeHours,
  wi as twelveHours,
  $ as useTimelineTheme,
  pr as weekDuration,
  Lt as yearDuration,
  le as zoomScaleWidth
};
